// event.component.ts
import { Component, OnInit, ViewChild, AfterContentInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ISlimScrollOptions } from 'ng2-slimscroll';
import * as _ from 'lodash';

import { AppService } from '../../app.service';
import { EventService } from './event.service';
import { TimeCurrencyService, TimeCurrencyInfo } from './../time-currency.service';

import {
  MessageEvent, SignInEvent, LoaderEvent, OpenFrameEvent, SidemenuToViewFacilityEvent,
  SidemenuSubCategory, HiddenFooter
} from './../../shared/message.event';

import { EventFacility, PricingTier, ActivityCharges } from './event-facility.interface';
import { EventValidation } from './event-validation';
import { UISETTING } from './../../shared/ui-setting';
import { EventBase } from './event-base';
import { UtilityFunctions } from '../../shared/utility-functions';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { CONSTANT_VALUES } from '../../constants/constant-values';

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.css'],
  providers: [
    EventService, MessageEvent, SignInEvent, LoaderEvent, OpenFrameEvent,
    SidemenuToViewFacilityEvent, SidemenuSubCategory, HiddenFooter, UtilityFunctions,
    TimeCurrencyService
  ]
})
export class EventComponent extends EventBase implements OnInit, AfterContentInit, OnDestroy {

  // Decimal restriction configuration
  pricingConfig = {
    maxValue: 999999,
    decimalPlaces: 2
  };

  /* ================================================================
     Template Element Refs for Toggle Buttons
  ===================================================================*/
  @ViewChild('butt1') butt1: any;
  @ViewChild('butt2') butt2: any;
  @ViewChild('butt3') butt3: any;
  @ViewChild('butt4') butt4: any;
  @ViewChild('butt17') butt17: any;
  @ViewChild('butt18') butt18: any;
  @ViewChild('butt27') butt27: any;
  @ViewChild('butt28') butt28: any;
  @ViewChild('butt31') butt31: any;
  @ViewChild('butt32') butt32: any;

  // Modal ViewChilds
  @ViewChild('activityPopUpObj') activityPopUpObj: any;
  @ViewChild('popUpObj') popUpObj: any;
  @ViewChild('confirmationForDataLosspopUpObj') confirmationForDataLosspopUpObj: any;
  @ViewChild('HomeSceenpopUpObj') HomeSceenpopUpObj: any;
  @ViewChild('alertImagePopUpObj') alertImagePopUpObj: any;

  // Pricing toggle buttons for 5-tier system with child pricing
  @ViewChild('memberOff') memberOff: any;
  @ViewChild('memberOn') memberOn: any;
  @ViewChild('nonMemberOff') nonMemberOff: any;
  @ViewChild('nonMemberOn') nonMemberOn: any;
  @ViewChild('guestOff') guestOff: any;
  @ViewChild('guestOn') guestOn: any;
  @ViewChild('corpMemberOff') corpMemberOff: any;
  @ViewChild('corpMemberOn') corpMemberOn: any;
  @ViewChild('corpNonMemberOff') corpNonMemberOff: any;
  @ViewChild('corpNonMemberOn') corpNonMemberOn: any;
  @ViewChild('memberChildOff') memberChildOff: any;
  @ViewChild('memberChildOn') memberChildOn: any;
  @ViewChild('nonMemberChildOff') nonMemberChildOff: any;
  @ViewChild('nonMemberChildOn') nonMemberChildOn: any;
  @ViewChild('guestChildOff') guestChildOff: any;
  @ViewChild('guestChildOn') guestChildOn: any;


  /* ================================================================
     Constants / Static Lists
  ===================================================================*/
  protected entries = CONSTANT_VALUES.ENTRIES;
  protected notificationPeriod = CONSTANT_VALUES.NOTIFICATION_PERIOD;
  protected hour_values = CONSTANT_VALUES.HOUR_VALUES;
  protected minute_values = CONSTANT_VALUES.MINUTE_VALUES;
  protected activity_end_time_hours = CONSTANT_VALUES.HOUR_VALUES_ACTIVITY_END_TIME;

  // Event Type Dropdown Options
  protected eventTypeOptions = [
    'Amenities',
    'Parking',
    'Activities',
    'Classes',
    'Workouts',
    'Fitness Sessions',
    'Yoga Sessions',
    'Dance Classes',
    'Movies',
    'Functions',
    'Talk Shows',
    'Festive Family Get Togethers',
    'Dining',
    'Cocktail Party',
    'Workshops',
    'Conferences',
    'Sports',
    'Cultural',
    'Business Meetings',
    'Training Sessions',
    'Networking',
    'Product Launches',
    'Award Ceremonies',
    'Other',
    'Links / Call to Action',
  ];

  /* ================================================================
     Page / UI State Variables
  ===================================================================*/
  protected shouldSlide = false;
  protected popupTitle = 'Error';
  protected popUpMessage: any = '';
  protected scrollOptions: ISlimScrollOptions;
  protected eventValidationObj: EventValidation;
  protected uiSetting: UISETTING;
  protected height: any;
  protected minDate = new Date();
  protected maxDate = new Date();
  protected yearRange: string = "2024:2030";
  private componentDestroyed = false;

  /* ================================================================
     Currency State Variables
  ===================================================================*/
  protected currencyInfo: TimeCurrencyInfo;
  protected selectedGlobalCurrency: string = '';
  protected currentCurrencyDisplay: string = '';

  /* ================================================================
     Event Objects
  ===================================================================*/
  protected facility: EventFacility;
  protected facilityArray: EventFacility[] = [];
  protected facility_list: EventFacility[] = [];
  protected iconImage: any;
  protected viewIcon = { name: '', iconClass: '' };
  protected tempFacilityId = '';
  protected redirectConfirmationMessage = '';
  protected groupList: any[] = [];
  public isopenGroups: boolean = false;


  /* ================================================================
     Application State Flags
  ===================================================================*/
  protected saveFlag = false;
  protected cancleButton = false;
  protected deleteMessage = false;
  protected cancleFlag = false;

  /* ================================================================
     Public Variables for Template Access
  ===================================================================*/
  public feed: any;
  public selectedCriteria = '';
  public filesToUpload: any;

  /* ================================================================
     Vendor / Category State
  ===================================================================*/
  protected currentCategory = {};
  protected vendor: any;

  /* ================================================================
     Public Properties for Template Access
  ===================================================================*/
  public addEventStatus: boolean = true;
  public pageName: string = 'Create Event';
  public clubName: string = '';
  public viewStatus: boolean = false;
  public editStatus: boolean = false;
  public isReadOnly: boolean = false;
  public openTime_hour: any;
  public openTime_minute: any;
  public closeTime_hour: any;
  public closeTime_minute: any;
  public isWaitlistEnabled: boolean = false;
  public isMaxBookingsPerSlot: boolean = true;
  public isGSTApplicable: boolean = false;
  public isAttendeeCountRequired: boolean = false;
  public isAllowForceBooking: boolean = false;
  public isCreatedForGroup: boolean = false;
  protected holdbookingdays = CONSTANT_VALUES.HOLDBOOKINGDAYS;

  constructor(
    private router: Router,
    private eventService: EventService,
    private openFrameEvent: OpenFrameEvent,
    private messageEvent: MessageEvent,
    private signInEvent: SignInEvent,
    private appService: AppService,
    private loaderEvent: LoaderEvent,
    private sidemenuSubCategory: SidemenuSubCategory,
    private sidemenuToViewFacilityEvent: SidemenuToViewFacilityEvent,
    private hiddenFooter: HiddenFooter,
    private utilityFunctions: UtilityFunctions,
    private timeCurrencyService: TimeCurrencyService
  ) {
    super();

    this.uiSetting = {
      windowHeight: window.innerHeight,
      topNav: 56,
      midNav: 45,
      container: 80,
      footer: 35
    };

    this.eventValidationObj = new EventValidation(
      this.appService,
      this.utilityFunctions,
      this.timeCurrencyService
    );

    // Initialize error messages (defensive)
    if (!this.eventValidationObj.errorMessages) {
      this.eventValidationObj.errorMessages = {
        dateError: '',
        eventTypeError: '',
        locationError: '',
        addressLine1Error: '',
        pincodeError: '',
        countryError: '',
        nameError: '',
        iconError: '',
        capacityError: '',
        timingError: '',
        gstError: '',
        waitlistError: '',
        reminderError: '',
        notificationError: '',
        memberAmountError: '',
        memberChildAmountError: '',
        nonMemberAmountError: '',
        nonMemberChildAmountError: '',
        guestAmountError: '',
        guestChildAmountError: '',
        corpMemberAmountError: '',
        corpNonMemberAmountError: ''
      };
    }

    // Load vendor first
    if (localStorage.getItem('vendor')) {
      this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
    }

    this.resetLocalState();

    this.scrollOptions = {
      barBackground: '#343a40',
      barOpacity: '0.6',
      position: 'right',
      barWidth: '6',
      barBorderRadius: '5',
      barMargin: '1px 1px',
      gridBackground: '#adb5bd',
      gridOpacity: '1',
      gridWidth: '4',
      gridBorderRadius: '10',
      gridMargin: '1px 2px'
    };

    this.height = (
      this.uiSetting.windowHeight -
      (this.uiSetting.topNav + this.uiSetting.midNav + this.uiSetting.container + this.uiSetting.footer)
    ) + 'px';

    this.iconImage = JSON.parse(JSON.stringify(CONSTANT_VALUES.ICON_LIST_IMAGE));
    this.redirectConfirmationMessage = CONSTANT_MESSAGES.REDIRECT_FROM_ACTIVITY;
  }

  /* ================================================================
     Lifecycle Hooks
  ===================================================================*/

  ngOnInit() {
    this.emitOpenFrameEvent();
    this.pageName = 'Create Event';

    if (localStorage.getItem('vendor')) {
      this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
      if (this.vendor.role == CONSTANT_VALUES.SUPER_ADMIN) {
        this.clubName = this.vendor.subVendors[0].name;
      } else {
        this.clubName = this.vendor.clubName;
      }
    }

    this.setFrameForFacilityRules();
    this.emitTypeBroadcast();
    this.registerTypeBroadcast();
    this.initializePricingWithDecimals();

    // Set date range for calendar
    this.minDate = new Date();
    this.minDate.setHours(0, 0, 0, 0);
    this.maxDate = new Date();
    this.maxDate.setFullYear(this.maxDate.getFullYear() + 2);

    const currentYear = new Date().getFullYear();
    this.yearRange = currentYear + ':' + (currentYear + 2);

    // Initialize currency info
    this.updateCurrencyInfo();

    this.feed = {
      title: '',
      content: '',
      vendorId: '',
      groups: [],
      members: [],
      sendToAllMembers: false,
      file: '',
      sendOn: '',
      sendToAllGroups: false,
      broadcastLink: ''
    };

    // CRITICAL: Load groups FIRST, then validate and set up toggles
    this.getGroupListByVendor();

    // CRITICAL FIX: Force all toggles to OFF after DOM is ready - ONLY for new events
    setTimeout(() => {
      this.validateAndToggleWaitlist();
      if (this.addEventStatus && !this.editStatus && !this.viewStatus) {
        this.forceAllPricingDataToFalse();
        this.initializeAllTogglesToOff();
      }
    }, 1500);
  }

  ngAfterContentInit() {
    // Additional DOM-dependent logic if required
  }

  ngOnDestroy() {
    this.componentDestroyed = true;
  }

  /* ================================================================
     FIXED PRICING TOGGLE METHODS
  ===================================================================*/

  /**
   * Enhanced toggle pricing - NEVER auto-enable child pricing
   */
  togglePricing(that: any, memberType: string, enabled: boolean): void {
    console.log(`=== PARENT TOGGLE CLICKED: ${memberType} = ${enabled} ===`);

    if (!that.facility.activityCharges) {
      that.facility.activityCharges = {} as ActivityCharges;
    }

    // Get currency info
    let currencyInfo: TimeCurrencyInfo;
    if (that.selectedGlobalCurrency && that.selectedGlobalCurrency !== '') {
      currencyInfo = that.getCurrencyInfoByCurrencyCode(that.selectedGlobalCurrency);
    } else {
      currencyInfo = that.timeCurrencyService.getTimeCurrencyInfo(that.vendor ? that.vendor.country : 'Singapore');
    }

    // Initialize pricing tier if it doesn't exist
    if (!that.facility.activityCharges[memberType]) {
      that.facility.activityCharges[memberType] = {
        enabled: false,
        amount: '',
        currency: currencyInfo.currency,
        currencyCode: currencyInfo.code,
        currencySymbol: currencyInfo.symbol,
        currencyName: currencyInfo.name,
        minorUnit: currencyInfo.minorUnit,
        country: currencyInfo.country
      } as PricingTier;

      // Initialize child pricing to FALSE for eligible tiers
      if (memberType === 'member' || memberType === 'nonMember' || memberType === 'guest') {
        that.facility.activityCharges[memberType].childEnabled = false;
        that.facility.activityCharges[memberType].childAmount = '';
      }
    }

    const pricingTier = that.facility.activityCharges[memberType] as PricingTier;

    // Set the enabled state for parent pricing
    pricingTier.enabled = enabled;

    if (enabled) {
      // When enabling parent pricing
      if (!pricingTier.amount || pricingTier.amount === '') {
        pricingTier.amount = '0.00';
      }

      // CRITICAL: ALWAYS ensure child pricing stays FALSE when parent is enabled
      if (memberType === 'member' || memberType === 'nonMember' || memberType === 'guest') {
        pricingTier.childEnabled = false;
        pricingTier.childAmount = '';
      }
    } else {
      // When disabling parent pricing
      pricingTier.amount = '';

      // Also disable child pricing when parent is disabled
      if (pricingTier.childEnabled !== undefined) {
        pricingTier.childEnabled = false;
        pricingTier.childAmount = '';
      }
    }

    // Update UI toggles
    that.updateToggleUI(memberType, enabled);

    // ALWAYS force child toggle to OFF when parent pricing is toggled
    if (memberType === 'member' || memberType === 'nonMember' || memberType === 'guest') {
      that.updateChildToggleUI(memberType, false);
    }

    console.log(`${memberType} pricing toggled: parent=${enabled}, child=FALSE`);
  }

  /**
   * Enhanced toggle child pricing with strict parent dependency
   */
  toggleChildPricing(that: any, memberType: string, enabled: boolean): void {
    console.log(`=== CHILD TOGGLE CLICKED: ${memberType} = ${enabled} ===`);

    if (!that.facility.activityCharges || !that.facility.activityCharges[memberType]) {
      console.warn('Cannot toggle child pricing: parent pricing tier not found for', memberType);
      return;
    }

    const pricingTier = that.facility.activityCharges[memberType] as PricingTier;

    // Only allow child pricing for member, nonMember, guest
    const childEligibleTiers = ['member', 'nonMember', 'guest'];
    if (childEligibleTiers.indexOf(memberType) === -1) {
      console.warn('Child pricing not available for', memberType);
      return;
    }

    // STRICT RULE: Parent pricing MUST be enabled first
    if (!pricingTier.enabled) {
      console.warn(`BLOCKING: Cannot enable child pricing - parent ${memberType} pricing is disabled`);
      // Force the child toggle to OFF state immediately
      pricingTier.childEnabled = false;
      pricingTier.childAmount = '';
      that.updateChildToggleUI(memberType, false);

      // Show user feedback
      console.log(`Child pricing blocked for ${memberType} - parent must be enabled first`);
      return;
    }

    // If parent is enabled, allow child pricing toggle
    pricingTier.childEnabled = enabled;

    if (enabled) {
      if (!pricingTier.childAmount || pricingTier.childAmount === '') {
        pricingTier.childAmount = '0.00';
      }
      console.log(`${memberType} child pricing ENABLED with amount: ${pricingTier.childAmount}`);
    } else {
      pricingTier.childAmount = '';
      console.log(`${memberType} child pricing DISABLED`);
    }

    // Force UI update
    that.updateChildToggleUI(memberType, enabled);

    console.log(`=== FINAL STATE: ${memberType} child=${pricingTier.childEnabled}, parent=${pricingTier.enabled} ===`);
  }

  /**
   * Update toggle UI state
   */
  private updateToggleUI(memberType: string, enabled: boolean): void {
    const toggleMapping = {
      'member': { on: 'memberOn', off: 'memberOff' },
      'nonMember': { on: 'nonMemberOn', off: 'nonMemberOff' },
      'guest': { on: 'guestOn', off: 'guestOff' },
      'corpMember': { on: 'corpMemberOn', off: 'corpMemberOff' },
      'corpNonMember': { on: 'corpNonMemberOn', off: 'corpNonMemberOff' }
    };

    const mapping = (toggleMapping as any)[memberType];
    if (mapping) {
      if (enabled) {
        this.setToggleClass(mapping.on, mapping.off);
      } else {
        this.setToggleClass(mapping.off, mapping.on);
      }
    }
  }

  /**
   * Update child toggle UI state
   */
  private updateChildToggleUI(memberType: string, enabled: boolean): void {
    const childToggleMapping = {
      'member': { on: 'memberChildOn', off: 'memberChildOff' },
      'nonMember': { on: 'nonMemberChildOn', off: 'nonMemberChildOff' },
      'guest': { on: 'guestChildOn', off: 'guestChildOff' }
    };

    const mapping = (childToggleMapping as any)[memberType];
    if (mapping) {
      if (enabled) {
        this.setToggleClass(mapping.on, mapping.off);
      } else {
        this.setToggleClass(mapping.off, mapping.on);
      }
    }
  }

  /**
   * Enhanced auto-disable with proper toggle UI updates
   */
  onPricingAmountChange(memberType: string, amount: string): void {
    if (!this.facility.activityCharges || !this.facility.activityCharges[memberType]) {
      return;
    }

    const pricingTier = this.facility.activityCharges[memberType];
    const numericAmount = parseFloat(amount || '0');

    if (numericAmount === 0 && pricingTier.enabled) {
      // Auto-disable toggle when amount is 0.00
      pricingTier.enabled = false;
      pricingTier.amount = '0.00';

      // Also disable child pricing
      if (pricingTier.childEnabled !== undefined) {
        pricingTier.childEnabled = false;
        pricingTier.childAmount = '';
      }

      // Update UI toggles
      this.updateToggleUI(memberType, false);
      if (memberType === 'member' || memberType === 'nonMember' || memberType === 'guest') {
        this.updateChildToggleUI(memberType, false);
      }

      console.log(memberType + ' pricing auto-disabled: amount is 0.00');
    }
  }

  onChildPricingAmountChange(memberType: string, childAmount: string): void {
    if (!this.facility.activityCharges || !this.facility.activityCharges[memberType]) {
      return;
    }

    const pricingTier = this.facility.activityCharges[memberType];
    const numericAmount = parseFloat(childAmount || '0');

    if (numericAmount === 0 && pricingTier.childEnabled) {
      // Auto-disable child toggle when amount is 0.00
      pricingTier.childEnabled = false;
      pricingTier.childAmount = '0.00';

      this.updateChildToggleUI(memberType, false);
      console.log(memberType + ' child pricing auto-disabled: amount is 0.00');
    }
  }

  /**
   * Enhanced setToggleClass method - ESSENTIAL for toggle functionality
   */
  setToggleClass(activeButton: string, inactiveButton: string): void {
    try {
      let activeElement = (this as any)[activeButton];
      let inactiveElement = (this as any)[inactiveButton];

      // Handle ViewChild references safely
      if (activeElement && activeElement.nativeElement) {
        activeElement = activeElement.nativeElement;
      }
      if (inactiveElement && inactiveElement.nativeElement) {
        inactiveElement = inactiveElement.nativeElement;
      }

      // Check if elements exist before manipulating
      if (activeElement && inactiveElement &&
        activeElement.classList && inactiveElement.classList) {

        // Apply active state (ON/green)
        activeElement.classList.remove('btn-toggle2');
        activeElement.classList.add('btn-toggle1');

        // Apply inactive state (OFF/gray)
        inactiveElement.classList.remove('btn-toggle1');
        inactiveElement.classList.add('btn-toggle2');

        console.log(`Toggle updated: ${activeButton} ACTIVE, ${inactiveButton} INACTIVE`);
      } else {
        console.warn(`Toggle elements not found:`, {
          activeButton,
          inactiveButton,
          activeElement: !!activeElement,
          inactiveElement: !!inactiveElement
        });
      }
    } catch (error) {
      console.error('Error in setToggleClass:', error);
    }
  }

  /**
   * Initialize ALL toggles to OFF state for new events
   */
  private initializeAllTogglesToOff(): void {
    setTimeout(() => {
      try {
        console.log('=== FORCING ALL TOGGLES TO OFF ===');

        // STEP 1: Set all basic toggles to OFF/NO state
        this.setToggleClass('butt2', 'butt1'); // Attendee Count: NO
        this.setToggleClass('butt4', 'butt3'); // Waitlisting: NO
        this.setToggleClass('butt18', 'butt17'); // Force Booking: NO
        this.setToggleClass('butt28', 'butt27'); // Group Target: NO
        this.setToggleClass('butt32', 'butt31'); // GST: OFF

        // STEP 2: Set ALL pricing toggles to OFF
        const pricingTiers = [
          { name: 'member', offRef: 'memberOff', onRef: 'memberOn' },
          { name: 'nonMember', offRef: 'nonMemberOff', onRef: 'nonMemberOn' },
          { name: 'guest', offRef: 'guestOff', onRef: 'guestOn' },
          { name: 'corpMember', offRef: 'corpMemberOff', onRef: 'corpMemberOn' },
          { name: 'corpNonMember', offRef: 'corpNonMemberOff', onRef: 'corpNonMemberOn' }
        ];

        for (let i = 0; i < pricingTiers.length; i++) {
          const tier = pricingTiers[i];
          this.setToggleClass(tier.offRef, tier.onRef); // FORCE OFF state
          console.log(`${tier.name} pricing toggle FORCED to OFF`);
        }

        // STEP 3: Set ALL child pricing toggles to OFF
        const childPricingTiers = [
          { name: 'member', offRef: 'memberChildOff', onRef: 'memberChildOn' },
          { name: 'nonMember', offRef: 'nonMemberChildOff', onRef: 'nonMemberChildOn' },
          { name: 'guest', offRef: 'guestChildOff', onRef: 'guestChildOn' }
        ];

        for (let i = 0; i < childPricingTiers.length; i++) {
          const tier = childPricingTiers[i];
          this.setToggleClass(tier.offRef, tier.onRef); // FORCE OFF state
          console.log(`${tier.name} child pricing toggle FORCED to OFF`);
        }

        console.log('=== ALL TOGGLES SUCCESSFULLY SET TO OFF ===');
      } catch (error) {
        console.error('Error in initializeAllTogglesToOff:', error);
      }
    }, 800);
  }

  /**
   * Force all pricing data to FALSE state
   */
  private forceAllPricingDataToFalse(): void {
    if (!this.facility || !this.facility.activityCharges) {
      return;
    }

    console.log('=== FORCING ALL PRICING DATA TO FALSE ===');

    // Force all pricing tiers to disabled state
    const pricingTiers = ['member', 'nonMember', 'guest', 'corpMember', 'corpNonMember'];

    for (let i = 0; i < pricingTiers.length; i++) {
      const tierName = pricingTiers[i];
      const pricingTier = this.facility.activityCharges[tierName];

      if (pricingTier) {
        // FORCE to false
        pricingTier.enabled = false;
        pricingTier.amount = '';

        // Also force child pricing to false for eligible tiers
        if (tierName === 'member' || tierName === 'nonMember' || tierName === 'guest') {
          pricingTier.childEnabled = false;
          pricingTier.childAmount = '';
        }

        console.log(`FORCED ${tierName}: enabled=false, childEnabled=false`);
      }
    }

    console.log('=== ALL PRICING DATA FORCED TO FALSE ===');
  }

  /**
   * Enhanced setToggleForViewFacility - preserves existing event data
   */
  setToggleForViewFacility() {
    console.log('=== SETTING TOGGLES FOR VIEW/EDIT MODE ===');

    // Basic facility toggles
    if (this.facility.isAttendeeCountRequired) {
      this.setToggleClass('butt1', 'butt2'); // ON state
    } else {
      this.setToggleClass('butt2', 'butt1'); // OFF state
    }

    if (this.facility.isWaitlistEnabled) {
      this.setToggleClass('butt3', 'butt4'); // ON state
    } else {
      this.setToggleClass('butt4', 'butt3'); // OFF state
    }

    if (this.facility.isAllowForceBooking) {
      this.setToggleClass('butt17', 'butt18'); // ON state
    } else {
      this.setToggleClass('butt18', 'butt17'); // OFF state
    }

    if (this.facility.isCreatedForGroup) {
      this.setToggleClass('butt27', 'butt28'); // ON state
    } else {
      this.setToggleClass('butt28', 'butt27'); // OFF state
    }

    if (this.facility.isGSTApplicable) {
      this.setToggleClass('butt31', 'butt32'); // ON state
    } else {
      this.setToggleClass('butt32', 'butt31'); // OFF state
    }

    // Enhanced pricing toggle states with proper error checking
    if (this.facility.activityCharges) {
      // Adult pricing toggles
      const pricingTiers = [
        { name: 'member', onRef: 'memberOn', offRef: 'memberOff' },
        { name: 'nonMember', onRef: 'nonMemberOn', offRef: 'nonMemberOff' },
        { name: 'guest', onRef: 'guestOn', offRef: 'guestOff' },
        { name: 'corpMember', onRef: 'corpMemberOn', offRef: 'corpMemberOff' },
        { name: 'corpNonMember', onRef: 'corpNonMemberOn', offRef: 'corpNonMemberOff' }
      ];

      for (let i = 0; i < pricingTiers.length; i++) {
        const tier = pricingTiers[i];
        const pricingTier = this.facility.activityCharges[tier.name];

        if (pricingTier && pricingTier.enabled) {
          this.setToggleClass(tier.onRef, tier.offRef); // ON state
          console.log(`${tier.name} pricing toggle set to ON`);
        } else {
          this.setToggleClass(tier.offRef, tier.onRef); // OFF state
          console.log(`${tier.name} pricing toggle set to OFF`);
        }
      }

      // Child pricing toggles (only for member, nonMember, guest)
      const childPricingTiers = [
        { name: 'member', onRef: 'memberChildOn', offRef: 'memberChildOff' },
        { name: 'nonMember', onRef: 'nonMemberChildOn', offRef: 'nonMemberChildOff' },
        { name: 'guest', onRef: 'guestChildOn', offRef: 'guestChildOff' }
      ];

      for (let i = 0; i < childPricingTiers.length; i++) {
        const tier = childPricingTiers[i];
        const pricingTier = this.facility.activityCharges[tier.name];

        if (pricingTier && pricingTier.enabled && pricingTier.childEnabled) {
          this.setToggleClass(tier.onRef, tier.offRef); // ON state
          console.log(`${tier.name} child pricing toggle set to ON`);
        } else {
          this.setToggleClass(tier.offRef, tier.onRef); // OFF state
          console.log(`${tier.name} child pricing toggle set to OFF`);
        }
      }
    }

    console.log('=== TOGGLE STATES INITIALIZED FOR VIEW/EDIT MODE ===');
  }

  /**
   * Helper method to check if child pricing is available for a tier
   */
  isChildPricingAvailable(memberType: string): boolean {
    const childEligibleTiers = ['member', 'nonMember', 'guest'];
    return childEligibleTiers.indexOf(memberType) !== -1;
  }

  /**
   * Helper method to check if child pricing is enabled and parent is enabled
   */
  isChildPricingEnabled(memberType: string): boolean {
    if (!this.facility.activityCharges || !this.facility.activityCharges[memberType]) {
      return false;
    }

    const pricingTier = this.facility.activityCharges[memberType];
    return pricingTier.enabled && pricingTier.childEnabled;
  }

  setDefaultWaitlist(that: any): void {
    if (that.isWaitlistEnabled && (!that.facility.waitlistCount || that.facility.waitlistCount === '')) {
      that.facility.waitlistCount = '3';
    }
  }

  /* ================================================================
     Currency Methods
  ===================================================================*/

  private updateCurrencyInfo(): void {
    const vendorCountry = this.vendor && this.vendor.country ? this.vendor.country : 'Singapore';
    this.currencyInfo = this.timeCurrencyService.getTimeCurrencyInfo(vendorCountry);
    this.updateCurrencyDisplay();
  }

  private updateCurrencyDisplay(): void {
    if (this.currencyInfo) {
      this.currentCurrencyDisplay = this.currencyInfo.symbol + ' ' + this.currencyInfo.currency + ' - ' + this.currencyInfo.name;
    } else {
      this.currentCurrencyDisplay = 'S$ SGD - Singapore Dollar';
    }
  }

  getCurrency(): string {
    return this.currencyInfo ? this.currencyInfo.currency : 'SGD';
  }

  getCurrencySymbol(): string {
    return this.currencyInfo ? this.currencyInfo.symbol : 'S$';
  }

  getCurrentCurrencyDisplay(): string {
    return this.currentCurrencyDisplay;
  }

  getExtendedMajorCurrencies(): TimeCurrencyInfo[] {
    return this.timeCurrencyService.getMajorCurrencies();
  }

  getMajorCountries(): TimeCurrencyInfo[] {
    return this.timeCurrencyService.getMajorCurrencies();
  }

  getOtherCountries(): TimeCurrencyInfo[] {
    const allCurrencies = this.timeCurrencyService.getAllCurrencies();
    const otherCountries: TimeCurrencyInfo[] = [];
    const majorCountryCodes = ['USD', 'INR', 'HKD', 'CNY', 'BND', 'IDR', 'KHR', 'LAK', 'MYR', 'MMK', 'PHP', 'SGD', 'THB', 'VND'];

    for (let i = 0; i < allCurrencies.length; i++) {
      if (majorCountryCodes.indexOf(allCurrencies[i].currency) === -1) {
        otherCountries.push(allCurrencies[i]);
      }
    }

    return otherCountries.sort(function (a, b) {
      return a.country.localeCompare(b.country);
    });
  }

  onCountryChange(selectedCountry: string): void {
    if (selectedCountry && this.facility) {
      this.facility.country = selectedCountry;
      this.generateFullLocation();
      console.log('Address country changed to:', selectedCountry, '- Pricing currency remains:', this.getCurrency());
    }
  }

  generateFullLocation(): void {
    if (!this.facility) return;

    const addressParts = [];

    if (this.facility.addressLine1) addressParts.push(this.facility.addressLine1.trim());
    if (this.facility.addressLine2) addressParts.push(this.facility.addressLine2.trim());
    if (this.facility.addressLine3) addressParts.push(this.facility.addressLine3.trim());
    if (this.facility.country) addressParts.push(this.facility.country.trim());
    if (this.facility.pincode) addressParts.push(this.facility.pincode.trim());

    this.facility.location = addressParts.join(', ');
  }

  onGlobalCurrencyChange(selectedCurrency: string): void {
    if (!this.facility.activityCharges) return;

    let currencyInfo: TimeCurrencyInfo;
    if (selectedCurrency && selectedCurrency !== '') {
      currencyInfo = this.getCurrencyInfoByCurrencyCode(selectedCurrency);
    } else {
      currencyInfo = this.timeCurrencyService.getTimeCurrencyInfo(this.vendor ? this.vendor.country : 'Singapore');
    }

    if (!currencyInfo) return;

    const categories = ['member', 'nonMember', 'guest', 'corpMember', 'corpNonMember'];

    for (let i = 0; i < categories.length; i++) {
      const category = categories[i];
      if (this.facility.activityCharges && this.facility.activityCharges[category]) {
        this.facility.activityCharges[category].currency = currencyInfo.currency;
        this.facility.activityCharges[category].currencyCode = currencyInfo.code;
        this.facility.activityCharges[category].currencySymbol = currencyInfo.symbol;
        this.facility.activityCharges[category].currencyName = currencyInfo.name;
        this.facility.activityCharges[category].minorUnit = currencyInfo.minorUnit;
      }
    }

    if (this.facility.amount) {
      this.facility.amount.currency = currencyInfo.currency;
    }

    this.currencyInfo = currencyInfo;
    this.updateCurrencyDisplay();

    console.log('Pricing currency updated to:', currencyInfo.currency, '(' + currencyInfo.symbol + ')');
  }

  private getCurrencyInfoByCurrencyCode(currencyCode: string): TimeCurrencyInfo {
    const allCurrencies = this.timeCurrencyService.getAllCurrencies();

    for (let i = 0; i < allCurrencies.length; i++) {
      if (allCurrencies[i].currency === currencyCode) {
        return allCurrencies[i];
      }
    }

    return this.timeCurrencyService.getTimeCurrencyInfo('Singapore');
  }

  /* ================================================================
     Event Type Methods
  ===================================================================*/

  getEventTypeOptions(): string[] {
    return this.eventTypeOptions;
  }

  onEventTypeChange(selectedEventType: string): void {
    if (selectedEventType && this.facility) {
      this.facility.eventType = selectedEventType;

      if (this.eventValidationObj) {
        this.eventValidationObj.validateFacility(this, 'facility.eventType', selectedEventType);
      }

      console.log('Event type set to:', selectedEventType);
    }
  }

  /* ================================================================
     Calendar Methods
  ===================================================================*/

  private formatDateTimeWithZeroTime(date: Date): string {
    if (!date || isNaN(date.getTime())) {
      return '';
    }

    try {
      // Create a new date to avoid mutations
      const normalizedDate = new Date(date);
      normalizedDate.setHours(0, 0, 0, 0); // Ensure 00:00:00.000

      const year = normalizedDate.getFullYear();
      const month = ('0' + (normalizedDate.getMonth() + 1)).slice(-2);
      const day = ('0' + normalizedDate.getDate()).slice(-2);

      // Always set time components to 00:00:00.000
      const hours = '00';
      const minutes = '00';
      const seconds = '00';
      const milliseconds = '000';

      // Format: YYYY-MM-DD 00:00:00.000
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
    } catch (error) {
      console.error('Error formatting date with zero time:', error);
      return date.toISOString();
    }
  }

  /**
   * Ensure dateObj and date string are synchronized
   */
  private synchronizeDateValues(): void {
    if (!this.facility) {
      return;
    }

    if (this.facility.dateObj && !this.facility.date) {
      // If we have dateObj but no date string
      this.facility.date = this.formatDateTimeWithZeroTime(this.facility.dateObj);
    } else if (this.facility.date && !this.facility.dateObj) {
      // If we have date string but no dateObj
      this.facility.dateObj = new Date(this.facility.date);
    } else if (this.facility.date && this.facility.dateObj) {
      // If both exist, check if they match
      const dateObjString = this.formatDateTimeWithZeroTime(this.facility.dateObj);
      if (dateObjString !== this.facility.date) {
        // Prefer dateObj as source of truth and update string
        this.facility.date = this.formatDateTimeWithZeroTime(this.facility.dateObj);
      }
    }
  }

  onCalendarDateSelect(selectedDate: Date): void {
    if (selectedDate && this.facility) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);

      if (selectedDate < today) {
        this.setDateValidationError(CONSTANT_MESSAGES.EVENT_DATE_PAST_ERROR);
        this.facility.dateObj = null;
        this.facility.date = '';
        return;
      }

      const maxFutureDate = new Date();
      maxFutureDate.setFullYear(maxFutureDate.getFullYear() + 2);
      maxFutureDate.setHours(23, 59, 59, 999);

      if (selectedDate > maxFutureDate) {
        this.setDateValidationError(CONSTANT_MESSAGES.EVENT_DATE_FUTURE_ERROR);
        this.facility.dateObj = null;
        this.facility.date = '';
        return;
      }

      // Create enhanced date with 00:00:00.000 time format
      const normalizedDate = new Date(selectedDate);
      normalizedDate.setHours(0, 0, 0, 0); // Set to 00:00:00.000

      // Format as YYYY-MM-DD 00:00:00.000
      this.facility.date = this.formatDateTimeWithZeroTime(normalizedDate);
      this.facility.dateObj = new Date(normalizedDate);;

      this.clearDateValidationError();

      if (this.eventValidationObj) {
        this.eventValidationObj.validateFacility(this, 'facility.date', this.facility.date);
      }

      console.log('Event date with 00:00 time format:', this.facility.date);
    }
  }


  onCalendarClear(): void {
    if (this.facility) {
      this.facility.date = '';
      this.facility.dateObj = null;

      this.setDateValidationError(CONSTANT_MESSAGES.EVENT_DATE_REQUIRED);

      if (this.eventValidationObj) {
        this.eventValidationObj.validateFacility(this, 'facility.date', '');
      }
    }
  }

  private setDateValidationError(message: string): void {
    if (this.eventValidationObj) {
      if (!this.eventValidationObj.validate) {
        this.eventValidationObj.validate = {};
      }

      this.eventValidationObj.validate.validDate = 'error';
      this.eventValidationObj.errorMessages.dateError = message;
    }
  }

  private clearDateValidationError(): void {
    if (this.eventValidationObj) {
      if (this.eventValidationObj.validate) {
        this.eventValidationObj.validate.validDate = 'success';
      }
      if (this.eventValidationObj.errorMessages) {
        this.eventValidationObj.errorMessages.dateError = '';
      }
    }
  }

  private initializeDateForCalendar(): void {
    if (this.facility && this.facility.date) {
      try {
        this.facility.dateObj = new Date(this.facility.date);
      } catch (e) {
        this.facility.dateObj = null;
      }
    } else if (this.facility) {
      this.facility.dateObj = null;
    }
  }

  /* ================================================================
     Icon Selection Methods
  ===================================================================*/

  selectIcon(iconObj: any): void {
    this.facility.icon = iconObj.name;
    this.viewIcon = { name: iconObj.name, iconClass: iconObj.iconClass };

    if (this.eventValidationObj) {
      this.eventValidationObj.validateFacility(this, 'icon', iconObj);
    }
  }

  onIconChange(iconObj: any): void {
    this.selectIcon(iconObj);

    // Update the hidden form field for validation
    this.facility.icon = iconObj.name;

    // Trigger validation
    if (this.eventValidationObj) {
      this.eventValidationObj.validateFacility(this, 'icon', iconObj);
    }
  }

  /* ================================================================
     Time Management Methods
  ===================================================================*/

  setTo24(): void {
    if (this.facility && this.facility.timings) {
      this.facility.timings.closeTime = this.utilityFunctions.setTo24(this.facility.timings.closeTime);
      console.log('Event close time set to 24:00 format:', this.facility.timings.closeTime);
    }
  }

  setActivityTimings(): void {
    if (this.facility && this.facility.timings) {
      this.facility.timings.closeTime = this.facility.timings.closeTime === '24:00:00:00' ? '23:59:00:00' : this.facility.timings.closeTime;
      console.log('Event timings set properly:', this.facility.timings.closeTime);
    }
  }

  handleEndTimeSelection(): void {
    if (this.closeTime_hour && this.closeTime_minute) {
      this.facility.timings.closeTime = this.closeTime_hour + ':' + this.closeTime_minute;

      if (this.closeTime_hour === '24') {
        this.setTo24();
      }
    }
  }

  prepareEventTimingsForSave(): void {
    this.buildTimingsFromComponents();
    this.setActivityTimings();
  }

  private buildTimingsFromComponents(): void {
    if (!this.facility.timings) {
      this.facility.timings = {
        openTime: '',
        closeTime: ''
      };
    }

    if (this.openTime_hour && this.openTime_minute) {
      this.facility.timings.openTime = this.openTime_hour + ':' + this.openTime_minute + ':00:00';
    }

    if (this.closeTime_hour && this.closeTime_minute) {
      this.facility.timings.closeTime = this.closeTime_hour + ':' + this.closeTime_minute + ':00:00';
    }
  }

  /* ================================================================
     Event Status Methods
  ===================================================================*/

  /**
   * Check if current event is completed/past
   */
  isCurrentEventCompleted(): boolean {
    if (!this.facility || !this.facility.date) {
      return false;
    }

    return !this.isEventUpcoming(this.facility);
  }

  getEventStatusClass(event: any): string {
    if (!event || !event.date) {
      return 'badge-secondary';
    }

    if (this.isEventUpcoming(event)) {
      return 'badge-success';
    } else {
      return 'badge-secondary';
    }
  }

  getEventStatusText(event: any): string {
    if (!event || !event.date) {
      return 'Invalid Date';
    }

    if (this.isEventUpcoming(event)) {
      return 'Upcoming';
    } else {
      return 'Completed';
    }
  }

  getEventStatusIcon(event: any): string {
    if (!event || !event.date) {
      return 'fa fa-exclamation-triangle';
    }

    if (this.isEventUpcoming(event)) {
      return 'fa fa-clock-o';
    } else {
      return 'fa fa-check-circle';
    }
  }

  /**
   * Navigate back to events dashboard
   */
  goBackToEventsDashboard(): void {
    if (this.componentDestroyed) return;

    if (localStorage.getItem('vendor')) {
      localStorage.removeItem('facility');
      localStorage.removeItem('currentCategory');
      this.router.navigate(['/events']);
    }
  }

  /* ================================================================
     Input Handlers for Decimal Formatting
  ===================================================================*/

  /**
   * Format any price value to always show .00
   */
  formatPriceDisplay(value: any): string {
    if (!value || value === '') {
      return '';
    }

    const numValue = parseFloat(value);
    if (isNaN(numValue)) {
      return '';
    }

    return numValue.toFixed(2);
  }

  /**
   * Initialize pricing values with .00 format
   */
  private initializePricingWithDecimals(): void {
    if (!this.facility || !this.facility.activityCharges) {
      return;
    }

    const tiers = ['member', 'nonMember', 'guest', 'corpMember', 'corpNonMember'];
    const childPricingTiers = ['member', 'nonMember', 'guest'];

    for (let i = 0; i < tiers.length; i++) {
      const tier = tiers[i];
      const pricingTier = this.facility.activityCharges[tier];
      if (pricingTier) {
        try {
          // Format adult pricing
          if (pricingTier.amount && pricingTier.amount !== '') {
            pricingTier.amount = this.formatPriceDisplay(pricingTier.amount);
          }

          // Format child pricing (only for member, nonMember, guest)
          if (childPricingTiers.indexOf(tier) !== -1) {
            if (pricingTier.childEnabled && pricingTier.childAmount && pricingTier.childAmount !== '') {
              pricingTier.childAmount = this.formatPriceDisplay(pricingTier.childAmount);
            }
          }
        } catch (error) {
          console.warn('Error formatting pricing for tier:', tier, error);
        }
      }
    }

    // Format GST with error handling
    try {
      if (this.facility.GSTValue && this.facility.GSTValue !== '') {
        this.facility.GSTValue = this.formatPriceDisplay(this.facility.GSTValue);
      }
    } catch (error) {
      console.warn('Error formatting GST value:', error);
    }
  }


  /**
* Merge activities from this.groupList for the provided groupIds with activityId (de-duped)
* and call linkService.updateGroups(...) to persist. Uses only this.groupList (no network calls).
*
* Returns a Promise resolving to update response or null on error.
*/
  public mergeActivitiesFromCacheAndUpdate(groupIds: string[], vendorId: string, activityId: string): Promise<any> {
    var self = this;

    if (!vendorId) {
      console.warn('mergeActivitiesFromCacheAndUpdate: missing vendorId, skipping');
      return Promise.resolve(null);
    }
    if (!activityId) {
      console.warn('mergeActivitiesFromCacheAndUpdate: missing activityId, skipping');
      return Promise.resolve(null);
    }

    // groupIds can be empty for new activities, but not for updates
    const newGroupIds = Array.isArray(groupIds) ? groupIds : [];

    return new Promise(function (resolve) {
      try {
        var groupsArr = Array.isArray(self.groupList) ? self.groupList : [];

        // STEP 1: Find all groups that currently have this activity (previous groups)
        var previousGroupIds: string[] = [];
        for (var i = 0; i < groupsArr.length; i++) {
          var group = groupsArr[i];
          if (group && Array.isArray(group.activities)) {
            // Check if this group contains the current activity
            for (var a = 0; a < group.activities.length; a++) {
              if (String(group.activities[a]) === String(activityId)) {
                previousGroupIds.push(group._id);
                break; // Found it, move to next group
              }
            }
          }
        }

        console.log('Previous group IDs for activity ' + activityId + ':', previousGroupIds);
        console.log('New group IDs from UI:', newGroupIds);

        // STEP 2: Merge previous and new group IDs (de-duplicate)
        var allGroupIdsMap: { [k: string]: boolean } = {};
        for (var i = 0; i < previousGroupIds.length; i++) {
          allGroupIdsMap[previousGroupIds[i]] = true;
        }
        for (var i = 0; i < newGroupIds.length; i++) {
          allGroupIdsMap[newGroupIds[i]] = true;
        }

        var allGroupIds: string[] = [];
        for (var gid in allGroupIdsMap) {
          if (allGroupIdsMap.hasOwnProperty(gid)) {
            allGroupIds.push(gid);
          }
        }

        console.log('Merged group IDs (previous + new):', allGroupIds);

        // If no groups at all, just skip
        if (allGroupIds.length === 0) {
          console.warn('mergeActivitiesFromCacheAndUpdate: no groups to update');
          return resolve(null);
        }

        // STEP 3: Collect all activities from these merged groups
        var activityMap: { [k: string]: boolean } = {};

        for (var i = 0; i < allGroupIds.length; i++) {
          var gid = allGroupIds[i];
          // Find group in local cache
          var found = null;
          for (var j = 0; j < groupsArr.length; j++) {
            if (groupsArr[j] && groupsArr[j]._id === gid) {
              found = groupsArr[j];
              break;
            }
          }

          if (found && Array.isArray(found.activities)) {
            // Add all activities from this group
            for (var a = 0; a < found.activities.length; a++) {
              var act = found.activities[a];
              if (act) {
                activityMap[String(act)] = true;
              }
            }
          }
        }

        // STEP 4: Include the current activity
        activityMap[String(activityId)] = true;

        // STEP 5: Convert to array
        var mergedActivities: string[] = [];
        for (var k in activityMap) {
          if (activityMap.hasOwnProperty(k)) {
            mergedActivities.push(k);
          }
        }

        console.log('Final merged activities for all groups:', mergedActivities);
        console.log('Updating ' + allGroupIds.length + ' groups with ' + mergedActivities.length + ' activities');

        // STEP 6: Update ALL groups (previous + new) with the merged activity list
        try {
          self.eventService.updateGroups(allGroupIds, vendorId, mergedActivities)
            .then(function (res: any) {
              if (!(res && (res.status === 'SUCCESS' || res.status === 'OK'))) {
                console.warn('mergeActivitiesFromCacheAndUpdate: update returned non-success:', res);
              } else {
                console.log('✓ Successfully updated ' + allGroupIds.length + ' groups with ' + mergedActivities.length + ' activities');
                console.log('✓ Groups updated:', allGroupIds);
              }
              resolve(res);
            })
            .catch(function (err: any) {
              console.warn('mergeActivitiesFromCacheAndUpdate: update failed:', err);
              resolve(null);
            });
        } catch (e) {
          console.warn('mergeActivitiesFromCacheAndUpdate: update threw', e);
          resolve(null);
        }
      } catch (ex) {
        console.warn('mergeActivitiesFromCacheAndUpdate: unexpected error', ex);
        resolve(null);
      }
    });
  }

  /* ================================================================
     CRUD Methods
  ===================================================================*/

  addEvents(popUpObj: any) {
    try {
      this.loaderEvent.fire(false);
      this.cancleButton = true;
      this.saveFlag = true;

      this.checkAndDisablePeakAndBreakTime();

      // Validate vendor before proceeding
      if (!this.vendor || !this.vendor._id) {
        this.loaderEvent.fire(true);
        this.popUpMessage = CONSTANT_MESSAGES.INVALID_VENDOR_ERROR;
        popUpObj.showChildModal();
        return;
      }

      // Run validation once and store result
      const isValid = this.eventValidationObj && this.eventValidationObj.validateFacilityObj(this);
      if (!isValid) {
        this.loaderEvent.fire(true);
        this.scrollToFirstError();
        return;
      }

      // Clean up data before validation
      this.cleanUpBeforeSave();

      // Set createdBy field
      if (!this.facility.createdBy || this.facility.createdBy === '') {
        if (
          this.vendor.role === CONSTANT_VALUES.SUPER_ADMIN &&
          this.vendor.subVendors &&
          this.vendor.subVendors.length > 0
        ) {
          this.facility.createdBy = this.vendor.subVendors[0]._id;
        } else {
          this.facility.createdBy = this.vendor._id;
        }
        console.log('Final addEvents check - CreatedBy set to:', this.facility.createdBy);
      }

      // Validate event timings
      if (!this.facility.timings || !this.facility.timings.openTime || !this.facility.timings.closeTime) {
        this.loaderEvent.fire(true);
        this.popUpMessage = CONSTANT_MESSAGES.EVENT_TIMINGS_REQUIRED;
        popUpObj.showChildModal();
        return;
      }

      // Validate event functionality
      const validation = this.eventService.validateEventFunctionality(
        this.facility.timings,
        this.facility.category
      );

      if (validation.status !== 300) {
        this.loaderEvent.fire(true);
        this.popUpMessage = validation.message;
        popUpObj.showChildModal();
        return;
      }

      // Validate pricing data if any pricing tier is enabled
      if (!this.validatePricingData()) {
        this.loaderEvent.fire(true);
        this.popUpMessage = 'Please fix pricing validation errors';
        popUpObj.showChildModal();
        return;
      }

      // Set final facility data
      this.setFacilityData();
      this.buildTimingsFromComponents();

      console.log('Event facility data before save:', {
        createdBy: this.facility.createdBy,
        vendorId: this.facility.vendorId,
        name: this.facility.name,
        activityCharges: this.facility.activityCharges,
        timings: this.facility.timings
      });

      // Save the event
      this.eventService
        .addEvent(this.facility)
        .then((result: any) => {
          // ---- NEW GROUP BOOKING FLOW (as requested) ----
          const saved = (result && result.facilityData) ? result.facilityData : null;
          const ok = (result && result.status === 'SUCCESS' && !!saved);

          if (ok) {
            console.log('GroupBooking event saved successfully:', saved);

            // clear any drafts
            localStorage.removeItem('facility');
            localStorage.removeItem('currentCategory');
            this.loaderEvent.fire(true);

            // Build payload from the saved facility
            const groupIds: string[] = Array.isArray(saved.targetGroupIds) ? saved.targetGroupIds : [];

            // Prefer component method; fall back to saved/vendor
            const computedVendorId =
              (typeof this.getVendorId === 'function' && this.getVendorId()) ||
              (saved && saved.vendorId) ||
              (this.vendor ? this.vendor._id : '');

            const activityId: string = (saved && saved._id) ? String(saved._id) : '';

            if (computedVendorId && activityId && groupIds.length > 0) {

              // fire-and-forget; don't block the UX
              this.mergeActivitiesFromCacheAndUpdate(groupIds, computedVendorId, activityId)
                .then((upd: any) => {
                  if (!(upd && upd.status === 'SUCCESS')) {
                    console.warn('Group update returned non-success:', (upd && upd.message) || upd);
                  }
                })
                .catch((err: any) => console.warn('Group update failed:', err));
            } else {
              if (!computedVendorId) console.warn('Skipped group update: missing vendorId');
              if (!activityId) console.warn('Skipped group update: missing activityId');
              if (!groupIds.length) console.warn('Skipped group update: empty groupIds');
            }

            // Redirect to group bookings list after success
            this.router.navigate(['/events']);
          } else {
            // original failure handling
            this.loaderEvent.fire(true);
            this.popUpMessage = (result && result.message) ? result.message : 'Failed to save event';
            popUpObj.showChildModal();
          }
          // ---- END NEW FLOW ----
        })
        .catch((error: any) => {
          console.error('Error saving event:', error);
          this.loaderEvent.fire(true);
          this.popUpMessage = 'An error occurred while saving the event';
          popUpObj.showChildModal();
        });
    } catch (e) {
      console.error('Exception in addEvents:', e);
      this.loaderEvent.fire(true);
      this.popUpMessage = 'An unexpected error occurred';
      popUpObj.showChildModal();
    }
  }

  updateEvent(popUpObj: any) {
    try {
      this.loaderEvent.fire(false);
      this.cancleButton = true;
      this.checkAndDisablePeakAndBreakTime();

      if (!this.vendor || !this.vendor._id) {
        this.loaderEvent.fire(true);
        this.popUpMessage = CONSTANT_MESSAGES.INVALID_VENDOR_ERROR;
        popUpObj.showChildModal();
        return;
      }

      const isValid = this.eventValidationObj.validateFacilityObj(this);
      if (!isValid) {
        this.loaderEvent.fire(true);
        return;
      }

      this.cleanUpBeforeSave();

      if (!this.facility.timings || !this.facility.timings.openTime || !this.facility.timings.closeTime) {
        this.loaderEvent.fire(true);
        this.popUpMessage = CONSTANT_MESSAGES.EVENT_TIMINGS_REQUIRED;
        popUpObj.showChildModal();
        return;
      }

      const validation = this.eventService.validateEventFunctionality(
        this.facility.timings,
        this.facility.category
      );

      if (validation.status !== 300) {
        this.loaderEvent.fire(true);
        this.popUpMessage = validation.message;
        popUpObj.showChildModal();
        return;
      }

      // Validate pricing data if any pricing tier is enabled
      if (!this.validatePricingData()) {
        this.loaderEvent.fire(true);
        this.popUpMessage = 'Please fix pricing validation errors';
        popUpObj.showChildModal();
        return;
      }

      this.setFacilityData();

      if (!this.facility.createdBy || this.facility.createdBy === '') {
        if (this.vendor.role === CONSTANT_VALUES.SUPER_ADMIN &&
          this.vendor.subVendors &&
          this.vendor.subVendors.length > 0
        ) {
          this.facility.createdBy = this.vendor.subVendors[0]._id;
        } else {
          this.facility.createdBy = this.vendor._id;
        }
        console.log('Final createdBy fallback set to:', this.facility.createdBy);
      }

      console.log('Event facility data before update:', {
        createdBy: this.facility.createdBy,
        vendorId: this.facility.vendorId,
        name: this.facility.name
      });

      this.buildTimingsFromComponents();

      // STEP 1: Update the event in the database first
      this.eventService.updateEvent(this.facility)
        .then((result: any) => {
          if (result.status === 'SUCCESS') {
            console.log('Event updated successfully');

            // STEP 2: Now update the group associations
            const groupIds = this.facility.targetGroupIds || [];
            const vendorId = this.getVendorId() || '';
            const activityId = this.facility._id;

            if (groupIds.length > 0 && vendorId && activityId) {
              // Update groups with the merged activities
              this.mergeActivitiesFromCacheAndUpdate(groupIds, vendorId, activityId)
                .then((groupUpdateResult: any) => {
                  if (groupUpdateResult && (groupUpdateResult.status === 'SUCCESS' || groupUpdateResult.status === 'OK')) {
                    console.log('Groups updated successfully');
                  } else {
                    console.warn('Group update returned non-success, but event was saved:', groupUpdateResult);
                  }

                  // Clear cache and navigate regardless of group update result
                  localStorage.removeItem('facility');
                  this.loaderEvent.fire(true);
                  this.router.navigate(['/events']);
                })
                .catch((err: any) => {
                  console.warn('Group update failed, but event was saved:', err);
                  // Still navigate since event was saved successfully
                  localStorage.removeItem('facility');
                  this.loaderEvent.fire(true);
                  this.router.navigate(['/events']);
                });
            } else {
              // No groups to update, just navigate
              console.log('No groups to update');
              localStorage.removeItem('facility');
              this.loaderEvent.fire(true);
              this.router.navigate(['/events']);
            }
          } else {
            // Event update failed
            this.loaderEvent.fire(true);
            this.popUpMessage = result.message || 'Failed to update event';
            popUpObj.showChildModal();
          }
        })
        .catch((error: any) => {
          console.error('Error updating event:', error);
          this.loaderEvent.fire(true);
          this.popUpMessage = 'An error occurred while updating the event';
          popUpObj.showChildModal();
        });
    } catch (err) {
      console.error('Exception in updateEvent:', err);
      this.loaderEvent.fire(true);
      this.popUpMessage = 'An unexpected error occurred';
      popUpObj.showChildModal();
    }
  }

  /**
   * Validate pricing data for enabled tiers
   */
  private validatePricingData(): boolean {
    if (!this.facility.activityCharges) {
      return true; // No pricing configured is valid
    }

    const pricingTiers = ['member', 'nonMember', 'guest', 'corpMember', 'corpNonMember'];

    for (let i = 0; i < pricingTiers.length; i++) {
      const tier = pricingTiers[i];
      const pricingTier = this.facility.activityCharges[tier];

      if (pricingTier && pricingTier.enabled) {
        // Check adult pricing
        if (!pricingTier.amount || parseFloat(pricingTier.amount) < 0) {
          if (this.eventValidationObj && this.eventValidationObj.errorMessages) {
            this.eventValidationObj.errorMessages[tier + 'AmountError'] = 'Please enter a valid price';
          }
          return false;
        }

        // Check child pricing if enabled (only for member, nonMember, guest)
        const childPricingTiers = ['member', 'nonMember', 'guest'];
        if (childPricingTiers.indexOf(tier) !== -1 && pricingTier && pricingTier.childEnabled) {
          if (!pricingTier.childAmount || parseFloat(pricingTier.childAmount) < 0) {
            if (this.eventValidationObj && this.eventValidationObj.errorMessages) {
              this.eventValidationObj.errorMessages[tier + 'ChildAmountError'] = 'Please enter a valid child price';
            }
            return false;
          }
        }
      }
    }

    return true;
  }

  /**
   * Scroll to first error field for better user experience
   */
  private scrollToFirstError(): void {
    setTimeout(() => {
      const firstError = document.querySelector('.validation-error:not(:empty), .invalid');
      if (firstError) {
        firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  }

  private cleanUpBeforeSave() {
    // Ensure it's always a string for validation
    if (this.facility.GSTValue) {
      this.facility.GSTValue = String(this.facility.GSTValue || '');
    }

    // Clean up pricing data
    if (this.facility.activityCharges) {
      const tiers = ['member', 'nonMember', 'guest', 'corpMember', 'corpNonMember'];
      for (let i = 0; i < tiers.length; i++) {
        const tier = tiers[i];
        const pricingTier = this.facility.activityCharges[tier];

        if (pricingTier && !pricingTier.enabled) {
          // Clear amounts for disabled tiers
          pricingTier.amount = '';
          if (pricingTier.childEnabled !== undefined) {
            pricingTier.childEnabled = false;
            pricingTier.childAmount = '';
          }
        }
      }
    }

    this.facility.name = (this.facility.name + '').trim();
    this.facility.notes = (this.facility.notes + '').trim();
    this.facility.eventType = (this.facility.eventType + '').trim();

    this.prepareEventTimingsForSave();

    this.facility.addressLine1 = (this.facility.addressLine1 || '').trim();
    this.facility.addressLine2 = (this.facility.addressLine2 || '').trim();
    this.facility.addressLine3 = (this.facility.addressLine3 || '').trim();
    this.facility.pincode = (this.facility.pincode || '').trim();
    this.facility.country = (this.facility.country || '').trim();

    this.generateFullLocation();

    if (!this.facility.createdBy || this.facility.createdBy === '') {
      if (this.vendor) {
        if (this.vendor.role === CONSTANT_VALUES.SUPER_ADMIN &&
          this.vendor.subVendors &&
          this.vendor.subVendors.length > 0) {
          this.facility.createdBy = this.vendor.subVendors[0]._id;
          this.facility.vendorId = this.vendor.subVendors[0]._id;
          console.log('CleanUp - Super Admin CreatedBy set to:', this.vendor.subVendors[0]._id);
        } else {
          this.facility.createdBy = this.vendor._id;
          this.facility.vendorId = this.vendor._id;
          console.log('CleanUp - Regular Vendor CreatedBy set to:', this.vendor._id);
        }
      }
    }

    if (this.facility.maxNumberOfPeople || this.facility.maxNumberOfPeople != '') {

      this.facility.maxNumberOfPeopleWeekday = this.facility.maxNumberOfPeople;
      this.facility.maxNumberOfPeopleWeekend = this.facility.maxNumberOfPeople;
    } else {
      this.facility.maxNumberOfPeopleWeekday = null;
      this.facility.maxNumberOfPeopleWeekend = null;
    }

    // This is requried field for backend processing so adding it here
    if (!this.facility.maxBookingsPerSlot || this.facility.maxBookingsPerSlot === '') {
      this.facility.maxBookingsPerSlot = '9999999999';
    }

    // CRITICAL: Ensure date consistency between string and object
    if (this.facility.dateObj && !this.facility.date) {
      // If we have dateObj but no date string, create with 00:00 time
      this.facility.date = this.formatDateTimeWithZeroTime(this.facility.dateObj);
    } else if (this.facility.date && !this.facility.dateObj) {
      // If we have date string, create dateObj and ensure 00:00 time
      const parsedDate = new Date(this.facility.date);
      if (!isNaN(parsedDate.getTime())) {
        parsedDate.setHours(0, 0, 0, 0); // Ensure 00:00:00.000
        this.facility.dateObj = parsedDate;
        this.facility.date = this.formatDateTimeWithZeroTime(parsedDate);
      }
    } else if (this.facility.date && this.facility.dateObj) {
      // Ensure both are synchronized with 00:00 time
      this.facility.dateObj.setHours(0, 0, 0, 0);
      this.facility.date = this.formatDateTimeWithZeroTime(this.facility.dateObj);
    }
    this.synchronizeDateValues();

    console.log('Date after cleanup:', {
      date: this.facility.date,
      dateObj: this.facility.dateObj
    });

    // Clean up event-specific fields
    this.facility.breakTimings = [];
    this.facility.peekTimings = [];
    this.facility.maxWeekdayBooking = '';
    this.facility.maxWeekendBooking = '';
    this.facility.maxBookingHoursWeekday = '';
    this.facility.maxBookingHoursWeekend = '';
    this.facility.maxBookingHoursMonth = '';
    this.facility.holdBookingDays = '';
    this.facility.peakUnitsCount = '0';
    this.facility.noOfUnits = '1';
    this.facility.unitNames = ['event'];

    this.facility.isPeakTimeEnabled = false;
    this.facility.isBreakTimeEnabled = false;
    this.facility.isSlotsLocked = true;
    this.facility.category = 'Events';
  }

  deleteFacility() {
    try {
      let facility = JSON.parse(this.appService.getFacility());
      let deleteFacilityObj = {
        'facilityId': facility._id,
        'vendorId': ''
      };

      if (this.vendor.role === CONSTANT_VALUES.SUPER_ADMIN && this.vendor.subVendors && this.vendor.subVendors.length > 0) {
        let subvendor = this.vendor.subVendors[0];
        deleteFacilityObj.vendorId = subvendor._id;
      } else {
        deleteFacilityObj.vendorId = this.vendor._id;
      }

      this.loaderEvent.fire(false);
      this.eventService.deleteEvent(deleteFacilityObj).then((result: any) => {
        if (result.status === 'SUCCESS') {
          this.router.navigate(['/events']);
        } else {
          this.loaderEvent.fire(true);
          this.popUpMessage = result.message;
        }
      }).catch((err) => {
        console.log(err);
        this.loaderEvent.fire(true);
      });
    } catch (err) {
      this.loaderEvent.fire(true);
      console.log(err);
    }
  }

  /* ================================================================
     Navigation and State Management Methods
  ===================================================================*/

  private resetLocalState() {
    this.isReadOnly = false;
    this.editStatus = false;
    this.openTime_hour = '';
    this.openTime_minute = '';
    this.closeTime_hour = '';
    this.closeTime_minute = '';
    this.selectedGlobalCurrency = '';

    const currencyInfo = this.timeCurrencyService
      ? this.timeCurrencyService.getTimeCurrencyInfo(this.vendor ? this.vendor.country : 'Singapore')
      : { currency: 'SGD', code: '702', symbol: 'S$', name: 'Singapore Dollar', country: 'Singapore', timezone: 'Asia/Singapore', timezoneAbbr: 'SGT', minorUnit: 'Cent' };

    this.facility = {
      _id: '',
      name: '',
      category: 'Events',
      eventType: '',
      date: '',
      dateObj: null,
      location: '',
      addressLine1: '',
      addressLine2: '',
      addressLine3: '',
      pincode: '',
      country: this.vendor ? this.vendor.country : 'Singapore',
      icon: '',
      notes: '',
      timings: { openTime: '', closeTime: '' },
      noOfUnits: '1',
      slotDuration: '',
      unitNames: ['event'],

      isAttendeeCountRequired: false,
      maxNumberOfPeople: '',
      maxNumberOfPeopleWeekday: '',
      maxNumberOfPeopleWeekend: '',
      isMaxBookingsPerSlot: true,
      maxBookingsPerSlot: '',
      eventCapacity: '',

      isWaitlistEnabled: false,
      waitlistCount: '',

      isAllowForceBooking: false,

      activityCharges: {
        member: {
          enabled: false,
          amount: '',
          childEnabled: false,
          childAmount: '',
          currency: currencyInfo.currency,
          currencyCode: currencyInfo.code,
          currencySymbol: currencyInfo.symbol,
          currencyName: currencyInfo.name,
          minorUnit: currencyInfo.minorUnit,
          country: currencyInfo.country
        },
        nonMember: {
          enabled: false,
          amount: '',
          childEnabled: false,
          childAmount: '',
          currency: currencyInfo.currency,
          currencyCode: currencyInfo.code,
          currencySymbol: currencyInfo.symbol,
          currencyName: currencyInfo.name,
          minorUnit: currencyInfo.minorUnit,
          country: currencyInfo.country
        },
        guest: {
          enabled: false,
          amount: '',
          childEnabled: false,
          childAmount: '',
          currency: currencyInfo.currency,
          currencyCode: currencyInfo.code,
          currencySymbol: currencyInfo.symbol,
          currencyName: currencyInfo.name,
          minorUnit: currencyInfo.minorUnit,
          country: currencyInfo.country
        },
        corpMember: {
          enabled: false,
          amount: '',
          currency: currencyInfo.currency,
          currencyCode: currencyInfo.code,
          currencySymbol: currencyInfo.symbol,
          currencyName: currencyInfo.name,
          minorUnit: currencyInfo.minorUnit,
          country: currencyInfo.country
        },
        corpNonMember: {
          enabled: false,
          amount: '',
          currency: currencyInfo.currency,
          currencyCode: currencyInfo.code,
          currencySymbol: currencyInfo.symbol,
          currencyName: currencyInfo.name,
          minorUnit: currencyInfo.minorUnit,
          country: currencyInfo.country
        }
      } as ActivityCharges,

      isGSTApplicable: false,
      GSTValue: '0.00',

      isChargable: false,
      amount: { currency: currencyInfo.currency, value: '' },

      isHoldBooking: false,
      holdBookingDays: '',

      reminder: { unit: 'hours', value: '' },
      notificationAcceptanceHour: '',

      isCreatedForGroup: false,
      targetGroupIds: [],

      vendorId: '',
      isActive: true,
      createdBy: '',
      timezoneOffset: new Date().getTimezoneOffset(),
      timezoneUTC: '',
      timezoneAbbr: '',

      isPeakTimeEnabled: false,
      isBreakTimeEnabled: false,
      isSlotsLocked: false,

      isMaxBookingPerMembership: false,
      isMaxBookingPerPerson: false,
      maxWeekdayBooking: '',
      maxWeekendBooking: '',
      maxBookingHoursWeekday: '',
      maxBookingHoursWeekend: '',
      maxBookingHoursMonth: '',

      peekStartTime: '',
      peekEndTime: '',
      peakUnitsCount: '',
      breakTimings: [],
      peekTimings: [],

      activitySlots: [],
      isCourtSelection: false,
      isOpenBookingOnFriday: false,
      isOpenNextMonthBooking: false,
      isWeeklyRepeatBooking: false,

      isAllowMemberNotes: false,
      memberNotesHintText: '',
      vendorNotesHintText: '',
      isAllowVendorNotes: false,
      showEventActivity: false,
    } as EventFacility;

    // Mirror flags on component
    this.isAttendeeCountRequired = false;
    this.isWaitlistEnabled = false;
    this.isAllowForceBooking = false;
    this.isCreatedForGroup = false;
    this.isGSTApplicable = false;
    this.ensureTargetGroupIds();

    this.updateCurrencyDisplay();

    console.log('=== LOCAL STATE RESET WITH SAFE DEFAULTS ===');
  }


  protected checkAndDisablePeakAndBreakTime() {
    this.facility.category = 'Events';
    this.facility.isPeakTimeEnabled = false;
    this.facility.isBreakTimeEnabled = false;
  }

  private emitOpenFrameEvent() {
    this.openFrameEvent.fire(false);
  }

  private emitTypeBroadcast() {
    const isShow = { privacypolicy: true, support: false, footer: 'block' };
    this.signInEvent.fire('block');
    this.hiddenFooter.fire(isShow);
   }

  private registerTypeBroadcast() {
    this.messageEvent.on().subscribe(message => {
      this.shouldSlide = message;
    });

    this.sidemenuToViewFacilityEvent.on().subscribe(message => {
      this.currentCategory = message;
      localStorage.setItem('currentCategory', btoa(JSON.stringify(message)));
      this.pageName = 'Create Event';
      this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
      this.addEventStatus = false;
      this.viewFacility('category');
    });
  }

  private setFrameForFacilityRules() {
    if (localStorage.getItem('facility')) {
      this.viewFacility('facility');
      if (localStorage.getItem('facilityList')) {
        this.facilityArray = JSON.parse(localStorage.getItem('facilityList'));
      }
    } else if (localStorage.getItem('currentCategory')) {
      this.currentCategory = JSON.parse(atob(localStorage.getItem('currentCategory')));
      this.viewFacility('category');
    } else {
      this.pageName = 'Create Event';
      this.addEventStatus = true;
    }
  }

  private viewFacility(frameName: string) {
    this.iconImage = JSON.parse(JSON.stringify(CONSTANT_VALUES.ICON_LIST_IMAGE));
    this.setFlagBeforeViewEvent(this);
    this.setFacilityForView(frameName);
    this.checkAndDisablePeakAndBreakTime();
    const cap = String(this.facility.eventCapacity).trim();

    if (cap === '9999999') {
      this.facility.eventCapacity = 'unlimited';
    }

    for (let i = 0; i < this.iconImage.length; i++) {
      const iconObj = this.iconImage[i];
      if (this.facility.icon === iconObj.name) {
        this.viewIcon = { name: iconObj.name, iconClass: iconObj.iconClass };
      }
    }

    if (this.facility) {
      this.sidemenuSubCategory.fire({
        category: this.facility.category,
        menu: 'Activities'
      });

      this.iconImage = CONSTANT_VALUES.ICON_LIST_IMAGE;

      this.setDefaultValues(this);
      this.setTimingsForEvent(this);

      // CRITICAL: Load target groups from the activities array in groups
      // This must be done AFTER groups are loaded
      this.loadTargetGroupsFromActivities();

      this.setToggleForViewFacility();
      this.eventValidationObj.validateFacilityObj(this);
      this.initializeDateForCalendar();
    } else {
      this.loaderEvent.fire(false);
      this.router.navigate(['/events']);
    }
  }

  /* ================================================================
   WAITLIST VALIDATION AND TOGGLE METHODS
===================================================================*/

  /**
   * Validate waitlist count and auto-disable toggle if empty or zero
   * Works regardless of current component state by checking all relevant flags
   */
  validateAndToggleWaitlist(): void {
    // Check if facility exists first
    if (!this.facility) {
      return;
    }

    // Get the current waitlist count from facility
    const facilityWaitlistCount = this.facility.waitlistCount;
    const waitlistCountNum = facilityWaitlistCount ? parseInt(facilityWaitlistCount.toString(), 10) : 0;

    // Check if waitlist should be disabled (empty, zero, or invalid count)
    const shouldDisableWaitlist = (
      !facilityWaitlistCount ||
      facilityWaitlistCount.toString().trim() === '' ||
      isNaN(waitlistCountNum) ||
      waitlistCountNum <= 0
    );

    // Check current toggle state from ALL sources
    const isCurrentlyEnabled = (
      this.isWaitlistEnabled ||
      this.facility.isWaitlistEnabled
    );

    // ONLY change toggle if there's actually a state change needed
    if (shouldDisableWaitlist) {
      // Disable waitlist in ALL relevant places
      this.isWaitlistEnabled = false;
      this.facility.isWaitlistEnabled = false;
      this.facility.waitlistCount = ''; // Clear facility waitlist count

      // Update toggle UI to OFF state (NO button active, YES button inactive)
      this.setToggleClass('butt4', 'butt3');

      console.log('Waitlist auto-disabled: facility.waitlistCount is empty/invalid');
      console.log('Updated state:', {
        facilityWaitlistEnabled: this.facility.isWaitlistEnabled,
        componentWaitlistEnabled: this.isWaitlistEnabled,
        facilityWaitlistCount: this.facility.waitlistCount
      });
    } else if (!shouldDisableWaitlist && facilityWaitlistCount && waitlistCountNum >= 1 && waitlistCountNum <= 3) {
      // Only ensure consistency if already enabled and count is valid
      const shouldBeEnabled = (
        this.isWaitlistEnabled ||
        this.facility.isWaitlistEnabled
      );

      if (shouldBeEnabled) {
        // Ensure both flags and facility are in sync when waitlist should be enabled
        this.isWaitlistEnabled = true;
        this.facility.isWaitlistEnabled = true;
        // Keep the facility waitlist count as-is since it's valid

        // Update toggle UI to ON state (YES button active, NO button inactive)
        this.setToggleClass('butt3', 'butt4');

        console.log('Waitlist state confirmed with valid facility.waitlistCount:', facilityWaitlistCount);
      }
    }
  }

  cancelFacility(popUpObj: any) {
    if (this.facility.category || this.facility.name ||
      this.openTime_hour || this.openTime_minute || this.closeTime_hour || this.closeTime_minute ||
      (this.facility.reminder && this.facility.reminder.value) ||
      this.facility.notificationAcceptanceHour ||
      this.facility.icon || this.facility.eventType || this.facility.date || this.facility.location ||
      this.facility.addressLine1 || this.facility.addressLine2 || this.facility.addressLine3 ||
      this.facility.pincode || this.facility.country) {
      this.popUpMessage = this.redirectConfirmationMessage;
      popUpObj.showChildModal();
    } else {
      this.confirmationForDataLoss(true);
    }
  }

  homeScreen(popUpObj: any) {
    try {
      if ((this.facility.category || this.facility.name ||
        this.openTime_hour || this.openTime_minute || this.closeTime_hour || this.closeTime_minute ||
        (this.facility.reminder && this.facility.reminder.value) ||
        this.facility.notificationAcceptanceHour ||
        this.facility.icon || this.facility.eventType || this.facility.date || this.facility.location ||
        this.facility.addressLine1 || this.facility.addressLine2 || this.facility.addressLine3 ||
        this.facility.pincode || this.facility.country) &&
        this.editStatus) {
        this.popUpMessage = this.redirectConfirmationMessage;
        popUpObj.showChildModal();
      } else {
        this.dataResetWhileHomeScreen(true);
      }
    } catch (err) {
      console.log(err);
    }
  }

  showFacilityByCategory(category: any) {
    try {
      let that = this;
      let vendor_facility_list: any[] = [];
      const facilityData = localStorage.getItem('vendor_eventsData');
      if (facilityData) {
        vendor_facility_list = JSON.parse(facilityData);
      }

      for (let i = 0; i < vendor_facility_list.length; i++) {
        const obj = vendor_facility_list[i];
        console.log('facility_list', obj.data);
        if (obj.categoryName === category) {


          this.facility_list = obj.data;
          break;
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  showFacility(facilityId: string) {
    this.tempFacilityId = facilityId;
    let facility = {};
    this.changeStatusATView();

    for (let i = 0; i < this.facility_list.length; i++) {
      const rec = this.facility_list[i];
      if (rec._id === facilityId) {
        facility = rec;
        break;
      }
    }

    if (facility && facility[0]) {
      localStorage.setItem('facility', JSON.stringify(facility[0]));
      this.viewFacility('facility');
    }
  }

  /**
  * Navigate to a specific event from breadcrumb
  */
  navigateToEvent(facilityId: string, event: Event): void {
    event.preventDefault(); // Prevent default link behavior

    if (this.editStatus) {
      // If in edit mode, show confirmation before navigating
      this.tempFacilityId = facilityId;
      this.popUpMessage = 'You have unsaved changes. Do you want to discard them and navigate to another event?';
      this.popupTitle = 'Unsaved Changes';
      this.cancleButton = true;

      // Store the facility ID for later use
      localStorage.setItem('pendingFacilityNavigation', facilityId);

      if (this.activityPopUpObj) {
        this.activityPopUpObj.showChildModal();
      }
    } else {
      // Navigate directly if not in edit mode
      this.navigateToFacilityDirect(facilityId);
    }
  }

  /**
   * Navigate directly to a facility
   */
  private navigateToFacilityDirect(facilityId: string): void {
    try {
      let targetFacility = null;

      // Find the target facility in the list
      for (let i = 0; i < this.facility_list.length; i++) {
        if (this.facility_list[i]._id === facilityId) {
          targetFacility = this.facility_list[i];
          break;
        }
      }

      if (targetFacility) {
        // Store the facility and navigate
        localStorage.setItem('facility', JSON.stringify(targetFacility));

        // Reset component state
        this.editStatus = false;
        this.viewStatus = true;
        this.addEventStatus = false;
        this.isReadOnly = true;

        // Update current facility
        this.facility = targetFacility;

        // Set toggles for the new facility
        this.setToggleForViewFacility();

        // Update UI components
        this.setDefaultValues(this);
        this.setTimingsForEvent(this);
        this.initializeDateForCalendar();

        console.log('Navigated to facility:', targetFacility.name);
      } else {
        console.error('Facility not found:', facilityId);
      }
    } catch (error) {
      console.error('Error navigating to facility:', error);
    }
  }

  /**
   * Enhanced navigation with proper state management
   */
  private navigateToFacility(facilityId: string): void {
    try {
      let targetFacility = null;

      // Find the target facility in the list
      for (let i = 0; i < this.facility_list.length; i++) {
        if (this.facility_list[i]._id === facilityId) {
          targetFacility = this.facility_list[i];
          break;
        }
      }

      if (targetFacility) {
        // Store the facility and navigate
        localStorage.setItem('facility', JSON.stringify(targetFacility));

        // Reset edit status and set to view mode
        this.editStatus = false;
        this.viewStatus = true;
        this.addEventStatus = false;
        this.isReadOnly = true;

        // Load the facility
        this.viewFacility('facility');

        console.log('Navigated to facility:', targetFacility.name);
      } else {
        console.error('Facility not found:', facilityId);
      }
    } catch (error) {
      console.error('Error navigating to facility:', error);
    }
  }

  /**
   * Check if current facility has been modified (for unsaved changes detection)
   */
  private originalFacility: EventFacility;

  /**
   * Store original facility data when entering edit mode
   */
  private storeOriginalFacility(): void {
    if (this.facility) {
      this.originalFacility = this.cloneFacility(this.facility);
    }
  }

  /**
   * Call this when entering edit mode
   */
  changeStatus(component: any): void {
    this.storeOriginalFacility(); // Store original before editing
    this.editStatus = true;
    this.isReadOnly = false;
  }

  changeStatusATView() {
    try {
      this.isReadOnly = true;
      this.editStatus = false;
      this.setDefaultValues(this);
    } catch (err) {
      console.log(err);
    }
  }

  changeCancleButton(popUpObj: any) {
    try {
      if (this.deleteMessage) {
        this.popupTitle = CONSTANT_MESSAGES.DELETE_CONFIRMATION_TITLE;
        this.popUpMessage = CONSTANT_MESSAGES.DELETE_CONFIRMATION;
      } else {
        this.popupTitle = CONSTANT_MESSAGES.EDIT_CONFIRMATION_TITLE;
        this.popUpMessage = CONSTANT_MESSAGES.EDIT_CONFIRMATION;
      }
      this.cancleButton = false;
      this.cancleFlag = true;
      popUpObj.showChildModal();
    } catch (err) {
      console.log(err);
    }
  }

  /**
 * Get filtered list of upcoming events for breadcrumb
 */
  getUpcomingFacilityList(): any[] {
    if (!this.facility_list || this.facility_list.length === 0) {
      return [];
    }

    return this.facility_list.filter(facility => {
      // Only include upcoming events in breadcrumb
      return this.isEventUpcoming(facility);
    });
  }

  /**
   * Enhanced event upcoming check with proper date validation
   */

  isEventUpcoming(event: any): boolean {
    if (!event || !event.date) {
      return false;
    }

    try {
      // Fixed: Replace optional chaining with explicit null checks
      const eventDate = event.date;
      const openTime = event.timings && event.timings.openTime ? event.timings.openTime : '';
      const closeTime = event.timings && event.timings.closeTime ? event.timings.closeTime : '';

      // Validate the date format first
      if (!this.isEventDateTimeValid(eventDate, openTime, closeTime)) {
        return false;
      }

      const eventDateObj = new Date(event.date);
      const today = new Date();

      // Set both dates to start of day for fair comparison
      today.setHours(0, 0, 0, 0);
      eventDateObj.setHours(0, 0, 0, 0);

      // Event is upcoming if it's today or in the future
      return eventDateObj >= today;
    } catch (error) {
      console.warn('Error checking if event is upcoming:', error);
      return false;
    }
  }

  /**
   * Enhanced method to check if current event is completed
   */
  // This will work in TypeScript 2.3.1
  isCurrentEventCompletedEnhanced(): boolean {
    if (!this.facility || !this.facility.date) {
      return true;
    }

    const openTime = this.facility.timings && this.facility.timings.openTime ? this.facility.timings.openTime : '';
    const closeTime = this.facility.timings && this.facility.timings.closeTime ? this.facility.timings.closeTime : '';

    if (!this.isEventDateTimeValid(this.facility.date, openTime, closeTime)) {
      return true;
    }

    return !this.isEventUpcoming(this.facility);
  }


  /**
   * Get count of upcoming events
   */
  getUpcomingEventCount(): number {
    return this.getUpcomingFacilityList().length;
  }

  /**
   * Get count of completed events
   */
  getCompletedEventCount(): number {
    if (!this.facility_list || this.facility_list.length === 0) {
      return 0;
    }

    return this.facility_list.filter(facility => !this.isEventUpcoming(facility)).length;
  }

  /**
   * Check if there are any upcoming events available
   */
  hasUpcomingEvents(): boolean {
    return this.getUpcomingEventCount() > 0;
  }

  /**
   * Check if all events in the list are completed
   */
  areAllEventsCompleted(): boolean {
    if (!this.facility_list || this.facility_list.length === 0) {
      return false;
    }

    return this.getCompletedEventCount() === this.facility_list.length;
  }
  /**
   * Enhanced confirmationFromVendor to handle breadcrumb navigation
   */
  confirmationFromVendor(message: boolean): void {
    if (this.componentDestroyed) return;

    try {
      if (message === true) {
        // Check if there's a pending navigation
        const pendingNavigation = localStorage.getItem('pendingFacilityNavigation');
        if (pendingNavigation) {
          localStorage.removeItem('pendingFacilityNavigation');
          this.navigateToFacilityDirect(pendingNavigation);
          return;
        }

        if (this.deleteMessage) {
          this.deleteFacility();
          this.deleteMessage = false;
          return;
        } else {
          this.router.navigate(['/events']);
        }
        if (this.saveFlag) {
          this.router.navigate(['/addevent']);
        }
        if (this.cancleFlag) {
          this.router.navigate(['/events']);
          this.cancleFlag = false;
        }
      } else {
        // User chose not to proceed
        this.deleteMessage = false;
        localStorage.removeItem('pendingFacilityNavigation');
      }
    } catch (err) {
      console.log(err);
    }
  }

  confirmDelete() {
    this.deleteMessage = true;
  }

  confirmationForDataLoss(bool: boolean) {
    if (bool) {
      if (localStorage.getItem('vendor')) {
        localStorage.removeItem('facility');
        localStorage.removeItem('currentCategory');
        this.router.navigate(['/events']);
      }
    }
  }

  dataResetWhileHomeScreen(bool: boolean) {
    if (bool) {
      if (localStorage.getItem('vendor')) {
        localStorage.removeItem('facility');
        localStorage.removeItem('currentCategory');
        this.utilityFunctions.homeScreen(this);
      }
    }
  }

  confirmForChangeActivity(facilityId: string, popUpObj: any) {
    this.tempFacilityId = facilityId;
    if (this.editStatus) {
      this.popUpMessage = this.redirectConfirmationMessage;
      popUpObj.showChildModal();
    } else {
      this.showFacility(this.tempFacilityId);
    }
  }

  saveFacilityId(facilityId: string) {
    this.tempFacilityId = facilityId;
  }

  /* ================================================================
     Toggle and UI Management Methods
  ===================================================================*/

  changeClassForToggle(toggleOwn: any, toggleOther: any) {
    toggleOwn.classList.remove('btn-toggle2');
    toggleOwn.classList.add('btn-toggle1');
    toggleOther.classList.remove('btn-toggle1');
    toggleOther.classList.add('btn-toggle2');
  }

  changeClass(): void {
    console.log('Toggle class changed');
  }

  /* ================================================================
     Utility and Helper Methods
  ===================================================================*/

  setFacilityForView(frameName: string) {
    if (this.facility.eventCapacity === '9999999') {
      this.facility.eventCapacity = 'unlimited';
    }

    if (frameName === 'facility') {
      this.facility = JSON.parse(this.appService.getFacility()) as EventFacility;
      this.showFacilityByCategory(this.facility.category);
    } else if (frameName === 'category') {
      this.showFacilityByCategory(this.currentCategory);
      if (this.facility_list && this.facility_list[0]) {
        this.appService.storeFacility(this.facility_list[0]);
        this.facility = JSON.parse(this.appService.getFacility()) as EventFacility;
      }
    }

  }

  setMinutes(hourVal: any, that: any, min: any) {
    this.utilityFunctions.setMinutes(hourVal, that, min);
  }
  computeMin(breakTimings) {
    const breakStart = breakTimings.start.split(':');
    let breakEnd = breakTimings.end.split(':');
    let breakStartMin = parseInt(breakStart[0]) * 60 + parseInt(breakStart[1]);
    let breakEndMin = parseInt(breakEnd[0]) * 60 + parseInt(breakEnd[1]);
    breakEndMin = breakEndMin == 1439 ? 1440 : breakEndMin;
    breakStartMin = breakStartMin == 1439 ? 1440 : breakStartMin;
    return { start: breakStartMin, end: breakEndMin }
  }

  checkAmenities() {
    let that = this;
    if (_.indexOf(CONSTANT_VALUES.AMENITIES, that.facility.category) >= 0) {
      this.amenitiesFlag = true;
      return true;
    } else {
      this.amenitiesFlag = false;
      return false;
    }
  }

  sortOnBookingStart(breakTImeArray) {
    breakTImeArray.sort(function (a, b) {
      return a.start - b.start;
    });
    return breakTImeArray;
  }

  calculateBookingStartTimeValues() {
    if (!this.facility || !this.facility.timings) {
      return [];
    }

    const openTime = this.facility.timings.openTime.split(':');
    const closeTime = this.facility.timings.closeTime ? this.facility.timings.closeTime.split(':') : null;

    if (!openTime || openTime.length < 2 || !closeTime || closeTime.length < 2) {
      console.warn('Invalid open or close time format');
      return [];
    }

    const openTimeMin = parseInt(openTime[0]) * 60 + parseInt(openTime[1]);
    const closeTimeMin = parseInt(closeTime[0]) * 60 + parseInt(closeTime[1]);

    let slotDuration = this.checkAmenities() ? 60 : parseInt(this.facility.slotDuration);
    if (isNaN(slotDuration) || slotDuration <= 0) {
      console.warn('Invalid slotDuration, defaulting to 60');
      slotDuration = 60;
    }

    if (openTimeMin >= closeTimeMin) {
      console.warn('Open time must be less than close time');
      return [];
    }

    let actualArr = [];
    let breakTimeMinArray = [];
    let breakTimings = [];

    breakTimings.push({ start: this.facility.timings.openTime, end: this.facility.timings.openTime });
    if (this.facility.breakTimings && this.facility.breakTimings.length > 0) {
      breakTimings = breakTimings.concat(this.facility.breakTimings);
    }
    breakTimings.push({ start: this.facility.timings.closeTime, end: this.facility.timings.closeTime });

    breakTimings.forEach(element => {
      const temp = this.computeMin(element);
      breakTimeMinArray.push(temp);
    });

    breakTimeMinArray = this.sortOnBookingStart(breakTimeMinArray);

    let i = 0;
    let nextBookingSlot = openTimeMin;

    // Safeguard: max iterations limit to prevent infinite loop
    const maxIterations = 1000;
    let iterationCount = 0;

    while (i < breakTimeMinArray.length - 1 && iterationCount < maxIterations) {
      if (
        breakTimeMinArray[i].end <= (nextBookingSlot + slotDuration) &&
        (slotDuration + nextBookingSlot) <= breakTimeMinArray[i + 1].start &&
        nextBookingSlot >= breakTimeMinArray[i].end &&
        nextBookingSlot < breakTimeMinArray[i + 1].start
      ) {
        const hour = ('0' + Math.floor(nextBookingSlot / 60)).slice(-2);
        const minute = ('0' + (nextBookingSlot % 60)).slice(-2);
        const str = hour + ':' + minute;
        actualArr.push(str);
        nextBookingSlot = nextBookingSlot + slotDuration;
      } else {
        i++;
        if (i < breakTimeMinArray.length) {
          nextBookingSlot = breakTimeMinArray[i].end;
        }
      }
      iterationCount++;
    }

    if (iterationCount === maxIterations) {
      console.warn('calculateBookingStartTimeValues: max iterations reached, possible loop issue');
    }

    return actualArr;
  }


  setFacilityData() {
    this.checkAndDisablePeakAndBreakTime();

    this.prepareEventTimingsForSave();

    if (this.vendor) {
      this.facility.timezoneOffset = this.vendor.timezoneOffset;
      this.facility.timezoneUTC = this.vendor.timezoneUTC;
      this.facility.timezoneAbbr = this.vendor.timezoneAbbr;

      if (this.vendor.role === CONSTANT_VALUES.SUPER_ADMIN &&
        this.vendor.subVendors &&
        this.vendor.subVendors.length > 0) {
        this.facility.vendorId = this.vendor.subVendors[0]._id;
        this.facility.createdBy = this.vendor.subVendors[0]._id;
      } else {
        this.facility.vendorId = this.vendor._id;
        this.facility.createdBy = this.vendor._id;
      }
    }

    this.eventValidationObj.setProperValuesToFacilityObj(this);

    this.facility.activitySlots = this.facility.isSlotsLocked ? this.calculateBookingStartTimeValues() : [];
    this.facility.slotDuration = this.calculateSlotDuration();
    this.facility.peekTimings = [];
    this.facility.breakTimings = [];
    this.facility.peakUnitsCount = '0';
    this.facility.noOfUnits = '1';
    this.facility.unitNames = ['event'];

    const currencyInfo = this.timeCurrencyService.getTimeCurrencyInfo(this.vendor ? this.vendor.country : 'Singapore');
    if (this.facility.amount) {
      this.facility.amount.currency = currencyInfo.currency;
    }

    if (!this.facility.targetGroupIds || this.facility.targetGroupIds.length === 0) {
      this.facility.isCreatedForGroup = false;
    }

    let capacity = this.facility.eventCapacity;

    if (typeof capacity === 'string') {
      capacity = capacity.trim().toLowerCase();

      if (capacity === '') {
        this.facility.eventCapacity = '0';               // string
      } else if (capacity === 'unlimited') {
        this.facility.eventCapacity = '9999999';         // string
      } else {
        this.facility.eventCapacity = String(Number(capacity)); // convert to string
      }
    } else {
      // Already a number: convert back to string
      this.facility.eventCapacity = String(Number(capacity) || 0);
    }

    this.updatePricingCurrency();
  }
  private updatePricingCurrency(): void {
    const currencyInfo = this.timeCurrencyService.getTimeCurrencyInfo(this.vendor ? this.vendor.country : 'Singapore');

    if (this.facility.activityCharges) {
      const categories = ['member', 'nonMember', 'guest', 'corpMember', 'corpNonMember'];

      for (let i = 0; i < categories.length; i++) {
        const category = categories[i];
        const pricingTier = (this.facility.activityCharges as any)[category] as PricingTier;
        if (pricingTier) {
          pricingTier.currency = currencyInfo.currency;
          pricingTier.currencyCode = currencyInfo.code;
          pricingTier.currencySymbol = currencyInfo.symbol;
          pricingTier.currencyName = currencyInfo.name;
          pricingTier.minorUnit = currencyInfo.minorUnit;
          pricingTier.country = currencyInfo.country;
        }
      }
    }
  }

  // Methods implemented to match EventBase interface
  public setFlagBeforeViewEvent(component: any): void {
    component.viewStatus = true;
    component.addEventStatus = false;
    component.editStatus = false;
    component.isReadOnly = true;
  }

  public setDefaultValues(component: any): void {
    component.isAttendeeCountRequired = component.facility.isAttendeeCountRequired || false;
    component.isWaitlistEnabled = component.facility.isWaitlistEnabled || false;
    component.isMaxBookingsPerSlot = true;
    component.isGSTApplicable = component.facility.isGSTApplicable || false;
  }

  public setTimingsForEvent(component: any): void {
    if (component.facility && component.facility.timings) {
      const openTime = component.facility.timings.openTime;
      const closeTime = component.facility.timings.closeTime;

      if (openTime) {
        const openTimeParts = openTime.split(':');
        component.openTime_hour = openTimeParts[0];
        component.openTime_minute = openTimeParts[1];
      }

      if (closeTime) {
        const closeTimeParts = closeTime.split(':');
        component.closeTime_hour = closeTimeParts[0];
        component.closeTime_minute = closeTimeParts[1];
      }
    }
  }

  public setFlagsForDisableBookings(component: any): void {
    component.facility.isMaxBookingPerMembership = false;
    component.facility.isMaxBookingPerPerson = false;
    component.facility.maxWeekdayBooking = '';
    component.facility.maxWeekendBooking = '';
    component.facility.maxBookingHoursWeekday = '';
    component.facility.maxBookingHoursWeekend = '';
    component.facility.maxBookingHoursMonth = '';
  }

  /* ================================================================
    SELECT MULTIPLE GROUPS
 ===================================================================*/

  toggleGroupSelection(groupId: string, evt?: Event) {
    if (!this.facility) return;
    this.ensureTargetGroupIds();

    const idx = this.facility.targetGroupIds.indexOf(groupId);
    if (idx === -1) {
      this.facility.targetGroupIds.push(groupId);
    } else {
      this.facility.targetGroupIds.splice(idx, 1);
    }

    // stop propagation if triggered from a click event on checkbox
    if (evt) {
      evt.stopPropagation();
    }
  }

  // Check if a given group is selected
  isGroupSelected(groupId: string): boolean {
    if (!this.facility || !this.facility.targetGroupIds) return false;
    return this.facility.targetGroupIds.indexOf(groupId) !== -1;
  }

  // Select all visible groups
  selectAllGroups(evt?: Event) {
    if (!this.facility) return;
    this.facility.targetGroupIds = this.groupList.map(g => g._id);
    if (evt) evt.stopPropagation();
  }
  // Clear all selection
  clearAllGroups(evt?: Event) {
    if (!this.facility) return;
    this.facility.targetGroupIds = [];
    if (evt) evt.stopPropagation();
  }


  // Label to show on the dropdown button
  getSelectedGroupLabel(): string {
    if (!this.groupList || this.groupList.length === 0) {
      return 'Error Getting Groups Please refresh!'; // replace with your stringConstants.TEXT_SELECT if needed
    }
    if (!this.facility || !this.facility.targetGroupIds || this.facility.targetGroupIds.length === 0) {
      return 'Group Selected (0)'; // or stringConstants.TEXT_SELECT
    }
    console.log('this.groupList', this.groupList);
    // Show up to 2 names then "... (N)"
    const labels: string[] = [];
    for (let id of this.facility.targetGroupIds) {
      const g = this.groupList.find(x => x._id === id);
      if (g) labels.push(g.name);
      if (labels.length >= 2) break;
    }
    if (this.facility.targetGroupIds.length > 2) {
      return labels.join(', ') + ' ... (' + this.facility.targetGroupIds.length + ')';
    }
    return labels.join(', ');
  }

  private ensureTargetGroupIds() {
    if (!this.facility) return;
    if (!this.facility.targetGroupIds || !Array.isArray(this.facility.targetGroupIds)) {
      this.facility.targetGroupIds = [];
    }
  }
  /**
   * Get vendor ID based on role
   */
  private getVendorId(): string {
    if (this.vendor.role === CONSTANT_VALUES.SUPER_ADMIN) {
      if (this.vendor.subVendors && this.vendor.subVendors.length > 0) {
        return this.vendor.subVendors[0]._id;
      }
    }
    return this.vendor._id;
  }

  getGroupListByVendor() {
    if (!this.vendor || !this.vendor._id) {
      console.warn('Vendor ID is missing, cannot fetch groups');
      return;
    }
    let vendorObj = {
      vendorId: this.getVendorId()
    };

    this.appService.getListOfGroup(vendorObj).then((result: any) => {
      if (result.status === 'SUCCESS') {
        this.groupList = result.groups;
      }
    });
  }


  toggle(component: any, toggleNumber: number, value: boolean): void {
    switch (toggleNumber) {
      case 1:
        component.facility.isAttendeeCountRequired = value;
        component.isAttendeeCountRequired = value;
        break;
      case 2:
        component.facility.isWaitlistEnabled = value;
        component.isWaitlistEnabled = value;
        break;
      case 10:
        component.facility.isAllowForceBooking = value;
        break;
      case 15:
        component.facility.isCreatedForGroup = value;
        // If enabling group targeting, load groups for vendor
        if (value) {
          // load group list (the method you shared)
          component.getGroupListByVendor();
        } else {
          // clear selected groups when disabling
          if (component.facility) {
            component.facility.targetGroupIds = [];
          }
          component.groupList = [];
        }
        break;
      case 17:
        component.facility.isGSTApplicable = value;
        component.isGSTApplicable = value;
        break;
      default:
        break;
    }
  }


  /* ================================================================
     File Upload Methods
  ===================================================================*/

  uploadFile(event: any, popUpObj: any): void {
    const files = event.target.files;
    if (files && files.length > 0) {
      const file = files[0];

      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/bmp', 'image/tiff'];
      if (allowedTypes.indexOf(file.type) === -1) {
        this.popUpMessage = CONSTANT_MESSAGES.INVALID_FILE_TYPE;
        popUpObj.showChildModal();
        return;
      }

      const maxSize = 5 * 1024 * 1024;
      if (file.size > maxSize) {
        this.popUpMessage = CONSTANT_MESSAGES.FILE_SIZE_EXCEEDED;
        popUpObj.showChildModal();
        return;
      }

      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.filesToUpload = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  removeImage(): void {
    this.filesToUpload = '';
  }

  /* ================================================================
     Date/Time Validation Methods - FIXED MISSING parseTimeString
  ===================================================================*/

  calculateSlotDuration() {
    let slotDurationOpenTime = parseInt(this.openTime_hour) * 60 + parseInt(this.openTime_minute);
    let slotDurationcloseTime = parseInt(this.closeTime_hour) * 60 + parseInt(this.closeTime_minute);
    let slotDuration = slotDurationcloseTime - slotDurationOpenTime;
    return slotDuration.toString();
  }
  /**
   * Parse time string - ESSENTIAL METHOD
   */
  private parseTimeString(timeString: string): { hours: number, minutes: number } {
    let hours = 0;
    let minutes = 0;

    try {
      const cleanTime = timeString.trim();
      const parts = cleanTime.split(':');

      if (parts.length >= 2) {
        hours = parseInt(parts[0], 10) || 0;
        minutes = parseInt(parts[1], 10) || 0;

        if (hours < 0 || hours > 23) hours = 0;
        if (minutes < 0 || minutes > 59) minutes = 0;
      }
    } catch (error) {
      console.warn('Error parsing time string:', timeString, error);
    }

    return { hours: hours, minutes: minutes };
  }

  private normalizeTimeTail(t?: string): string {
    if (!t) return '';
    const s = t.trim();
    // Older TS: avoid lookbehind; use simple test and slice
    const re = /^(\d{1,2}:\d{2}:\d{2}):00$/i;
    if (re.test(s)) {
      return s.slice(0, s.lastIndexOf(':'));
    }
    return s;
  }

  /**
   * Validate time string format (HH:mm, HH:mm:ss, HH:mm:ss:00, and 12h variants)
   */
  private isValidTimeString(timeString: string): boolean {
    if (!timeString || timeString.trim() === '') {
      return true; // Empty allowed in this app
    }

    const normalized = this.normalizeTimeTail(timeString);
    const upper = normalized.toUpperCase();

    // 24-hour with optional seconds
    const re24 = /^(?:[01]?\d|2[0-3]):[0-5]\d(?::[0-5]\d)?$/;

    // 12-hour with optional seconds
    const re12 = /^(?:0?[1-9]|1[0-2]):[0-5]\d(?::[0-5]\d)?\s?(AM|PM)$/i;

    return re24.test(upper) || re12.test(upper);
  }

  private isEventDateTimeValid(dateString: string, startTime?: string, endTime?: string): boolean {
    if (
      !dateString ||
      dateString.trim() === '' ||
      dateString === 'null' ||
      dateString === 'undefined' ||
      dateString === 'Invalid Date'
    ) {
      return false;
    }

    const cleanDateString = dateString.trim();

    try {
      let eventDate: Date = null;

      // ISO YYYY-MM-DD
      let match = cleanDateString.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (match) {
        const y = parseInt(match[1], 10);
        const m = parseInt(match[1], 10);
        const d = parseInt(match[2], 10);
        eventDate = new Date(y, m - 1, d);
        if (eventDate.getFullYear() !== y || eventDate.getMonth() !== m - 1 || eventDate.getDate() !== d) {
          return false;
        }
      }

      // US MM/DD/YYYY
      if (!eventDate) {
        match = cleanDateString.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
        if (match) {
          const m = parseInt(match[3], 10);
          const d = parseInt(match[1], 10);
          const y = parseInt(match[2], 10);
          eventDate = new Date(y, m - 1, d);
          if (eventDate.getFullYear() !== y || eventDate.getMonth() !== m - 1 || eventDate.getDate() !== d) {
            return false;
          }
        }
      }

      // Full ISO (fallback)
      if (!eventDate) {
        const tryDate = new Date(cleanDateString);
        if (isNaN(tryDate.getTime())) return false;
        eventDate = tryDate;
      }

      const year = eventDate.getFullYear();
      if (year < 1900 || year > 2100) return false;

      // Time strings
      const startNorm = this.normalizeTimeTail(startTime || '');
      const endNorm = this.normalizeTimeTail(endTime || '');

      if (startNorm && !this.isValidTimeString(startNorm)) return false;
      if (endNorm && !this.isValidTimeString(endNorm)) return false;

      return true;
    } catch (e) {
      return false;
    }
  }

  /**
   * Get current date/time in vendor's timezone
   */
  private getCurrentDateInVendorTimezone(): Date {
    const now = new Date();
    try {
      const vendorTimezone = this.vendor && this.vendor.timezoneUTC ? this.vendor.timezoneUTC : 'UTC';
      if (typeof Intl !== 'undefined' && (Intl as any).DateTimeFormat) {
        const vendorTime = new Date(now.toLocaleString("en-US", {
          timeZone: vendorTimezone
        }));
        return vendorTime;
      } else {
        if (this.vendor && this.vendor.timezoneOffset) {
          const offsetMinutes = parseInt(this.vendor.timezoneOffset, 10);
          const vendorTime = new Date(now.getTime() + (offsetMinutes * 60000));
          return vendorTime;
        }
        return now;
      }
    } catch (error) {
      console.warn('Invalid timezone, falling back to vendor timezone offset:', this.vendor ? this.vendor.timezoneUTC : 'unknown');
      if (this.vendor && this.vendor.timezoneOffset) {
        const offsetMinutes = parseInt(this.vendor.timezoneOffset, 10);
        const vendorTime = new Date(now.getTime() + (offsetMinutes * 60000));
        return vendorTime;
      }
      return now;
    }
  }

  /**
   * Parse event date/time with timezone
   */
  private parseEventDateTimeWithTimezone(event: any): { startDateTime: Date, endDateTime: Date } {
    const baseDate = new Date(event.date);
    if (isNaN(baseDate.getTime())) {
      return {
        startDateTime: new Date('1970-01-01'),
        endDateTime: new Date('1970-01-01')
      };
    }

    let startDateTime = new Date(baseDate);
    if (event.timings && event.timings.openTime) {
      const startTimeParts = this.parseTimeString(event.timings.openTime);
      startDateTime.setHours(startTimeParts.hours, startTimeParts.minutes, 0, 0);
    } else {
      startDateTime.setHours(0, 0, 0, 0);
    }

    let endDateTime = new Date(baseDate);
    if (event.timings && event.timings.closeTime) {
      const endTimeParts = this.parseTimeString(event.timings.closeTime);
      endDateTime.setHours(endTimeParts.hours, endTimeParts.minutes, 0, 0);
    } else {
      endDateTime.setHours(23, 59, 59, 999);
    }

    return { startDateTime: startDateTime, endDateTime: endDateTime };
  }

  /* ================================================================
     Utility Methods - TypeScript 2.3.1 Compatible
  ===================================================================*/

  /**
   * Get formatted time string for display - TypeScript 2.3.1 compatible
   */
  getFormattedTime(timeString: string): string {
    if (!timeString) return '';

    try {
      const timeParts = this.parseTimeString(timeString);
      const hours = timeParts.hours < 10 ? '0' + timeParts.hours : timeParts.hours.toString();
      const minutes = timeParts.minutes < 10 ? '0' + timeParts.minutes : timeParts.minutes.toString();
      return `${hours}:${minutes}`;
    } catch (error) {
      return timeString;
    }
  }

  /**
   * Get formatted date string for display
   */
  getFormattedDate(dateString: string): string {
    if (!dateString) return '';

    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;

      return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } catch (error) {
      return dateString;
    }
  }

  /**
   * Check if event has pricing configured
   */
  hasPricingConfigured(): boolean {
    if (!this.facility || !this.facility.activityCharges) {
      return false;
    }

    const tiers = ['member', 'nonMember', 'guest', 'corpMember', 'corpNonMember'];

    for (let i = 0; i < tiers.length; i++) {
      const tier = tiers[i];
      const pricingTier = this.facility.activityCharges[tier];

      if (pricingTier && pricingTier.enabled && pricingTier.amount && parseFloat(pricingTier.amount) > 0) {
        return true;
      }

      // Check child pricing for eligible tiers
      if ((tier === 'member' || tier === 'nonMember' || tier === 'guest') &&
        pricingTier && pricingTier.childEnabled && pricingTier.childAmount &&
        parseFloat(pricingTier.childAmount) > 0) {
        return true;
      }
    }

    return false;
  }

  /**
   * Get total pricing summary
   */
  getPricingSummary(): { adultTiers: number, childTiers: number, totalAmount: number } {
    let adultTiers = 0;
    let childTiers = 0;
    let totalAmount = 0;

    if (!this.facility || !this.facility.activityCharges) {
      return { adultTiers, childTiers, totalAmount };
    }

    const tiers = ['member', 'nonMember', 'guest', 'corpMember', 'corpNonMember'];

    for (let i = 0; i < tiers.length; i++) {
      const tier = tiers[i];
      const pricingTier = this.facility.activityCharges[tier];

      if (pricingTier && pricingTier.enabled && pricingTier.amount) {
        const amount = parseFloat(pricingTier.amount);
        if (amount > 0) {
          adultTiers++;
          totalAmount += amount;
        }
      }

      // Check child pricing for eligible tiers
      if ((tier === 'member' || tier === 'nonMember' || tier === 'guest') &&
        pricingTier && pricingTier.childEnabled && pricingTier.childAmount) {
        const childAmount = parseFloat(pricingTier.childAmount);
        if (childAmount > 0) {
          childTiers++;
          totalAmount += childAmount;
        }
      }
    }

    return { adultTiers, childTiers, totalAmount };
  }

  /**
   * Validate all required fields before save
   */
  validateRequiredFields(): boolean {
    if (!this.facility) {
      return false;
    }

    // Basic required fields
    if (!this.facility.name || this.facility.name.trim() === '') {
      return false;
    }

    if (!this.facility.eventType || this.facility.eventType.trim() === '') {
      return false;
    }

    if (!this.facility.date) {
      return false;
    }

    if (!this.facility.timings || !this.facility.timings.openTime || !this.facility.timings.closeTime) {
      return false;
    }

    if (!this.facility.addressLine1 || this.facility.addressLine1.trim() === '') {
      return false;
    }

    if (!this.facility.country || this.facility.country.trim() === '') {
      return false;
    }

    return true;
  }

  /**
   * Reset form to initial state
   */
  resetForm(): void {
    this.resetLocalState();

    // Clear validation errors
    if (this.eventValidationObj && this.eventValidationObj.errorMessages) {
      const errorKeys = Object.keys(this.eventValidationObj.errorMessages);
      for (let i = 0; i < errorKeys.length; i++) {
        this.eventValidationObj.errorMessages[errorKeys[i]] = '';
      }
    }

    // Reset component flags
    this.isAttendeeCountRequired = false;
    this.isWaitlistEnabled = false;
    this.isAllowForceBooking = false;
    this.isCreatedForGroup = false;
    this.isGSTApplicable = false;

    // Clear time components
    this.openTime_hour = '';
    this.openTime_minute = '';
    this.closeTime_hour = '';
    this.closeTime_minute = '';

    // Clear file upload
    this.filesToUpload = '';

    console.log('Form reset to initial state');
  }

  /**
   * Deep clone facility object
   */
  private cloneFacility(facility: EventFacility): EventFacility {
    return JSON.parse(JSON.stringify(facility));
  }

  /**
   * Compare two facility objects for changes
   */
  hasUnsavedChanges(original: EventFacility, current: EventFacility): boolean {
    if (!original || !current) {
      return false;
    }

    try {
      const originalJson = JSON.stringify(original);
      const currentJson = JSON.stringify(current);
      return originalJson !== currentJson;
    } catch (error) {
      console.warn('Error comparing facility objects:', error);
      return false;
    }
  }

  /**
   * Cleanup component on destroy
   */
  private cleanup(): void {
    this.componentDestroyed = true;

    // Clear any intervals/timeouts if needed
    // Remove any event listeners if needed

    console.log('Component cleanup completed');
  }

  /**
   * Log current event state for debugging
   */
  logEventState(): void {
    console.group('Event Component State');
    console.log('Facility:', this.facility);
    console.log('View Status:', this.viewStatus);
    console.log('Edit Status:', this.editStatus);
    console.log('Add Status:', this.addEventStatus);
    console.log('Read Only:', this.isReadOnly);
    console.log('Vendor:', this.vendor);

    if (this.facility && this.facility.activityCharges) {
      console.log('Pricing Summary:', this.getPricingSummary());
    }

    const validation = this.validateRequiredFields();
    console.log('Required Fields Valid:', validation);

    console.groupEnd();
  }

  /**
   * Load target groups from the groupList based on which groups contain this activity
   * Call this when viewing/editing an existing event
   */
  private loadTargetGroupsFromActivities(): void {
    if (!this.facility || !this.facility._id) {
      console.log('No facility ID to check for target groups');
      return;
    }

    if (!this.groupList || this.groupList.length === 0) {
      console.log('No groups available to check');
      return;
    }

    const activityId = this.facility._id;
    const targetGroupIds: string[] = [];

    // Scan through all groups to find which ones contain this activity
    for (let i = 0; i < this.groupList.length; i++) {
      const group = this.groupList[i];
      if (group && Array.isArray(group.activities)) {
        // Check if this group contains the current activity
        for (let a = 0; a < group.activities.length; a++) {
          if (String(group.activities[a]) === String(activityId)) {
            targetGroupIds.push(group._id);
            console.log('Found activity in group:', group.name, '(', group._id, ')');
            break; // Found it, move to next group
          }
        }
      }
    }

    // Set the target group IDs on the facility
    this.facility.targetGroupIds = targetGroupIds;

    // If groups were found, enable the "Created for Group" toggle
    if (targetGroupIds.length > 0) {
      this.facility.isCreatedForGroup = true;
      this.isCreatedForGroup = true;
      console.log('Activity is targeted to', targetGroupIds.length, 'group(s):', targetGroupIds);
    } else {
      this.facility.isCreatedForGroup = false;
      this.isCreatedForGroup = false;
      console.log('Activity is not targeted to any groups');
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/facility/event/event.component.ts